// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { fieldMaskFromJson, fieldMaskToJson, pagedRequestOptionsFromJson as vendastatypesPagedRequestOptionsFromJson, pagedRequestOptionsToJson as vendastatypesPagedRequestOptionsToJson, pagedResponseMetadataFromJson as vendastatypesPagedResponseMetadataFromJson, pagedResponseMetadataToJson as vendastatypesPagedResponseMetadataToJson } from '../../vendastatypes/codec';
export function aIThoughtToJson(m) {
    const o = {};
    if (m.sequenceNumber !== undefined)
        o['sequenceNumber'] = m.sequenceNumber;
    if (m.thoughtType !== undefined)
        o['thoughtType'] = m.thoughtType;
    if (m.content !== undefined)
        o['content'] = m.content;
    return o;
}
export function aIThoughtFromJson(o) {
    var _a, _b, _c;
    return {
        sequenceNumber: (_a = o['sequenceNumber']) !== null && _a !== void 0 ? _a : 0,
        thoughtType: (_b = o['thoughtType']) !== null && _b !== void 0 ? _b : '',
        content: (_c = o['content']) !== null && _c !== void 0 ? _c : '',
    };
}
export function aISystemMessageToJson(m) {
    const o = {};
    if (m.systemMessageId !== undefined)
        o['systemMessageId'] = m.systemMessageId;
    if (m.systemMessageBody !== undefined)
        o['systemMessageBody'] = m.systemMessageBody;
    if (m.iamUserId !== undefined)
        o['iamUserId'] = m.iamUserId;
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function aISystemMessageFromJson(o) {
    var _a, _b, _c;
    return {
        systemMessageId: (_a = o['systemMessageId']) !== null && _a !== void 0 ? _a : '',
        systemMessageBody: (_b = o['systemMessageBody']) !== null && _b !== void 0 ? _b : '',
        iamUserId: (_c = o['iamUserId']) !== null && _c !== void 0 ? _c : '',
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function upsertAISystemMessageRequestToJson(m) {
    const o = {};
    if (m.systemMessage !== undefined)
        o['systemMessage'] = aISystemMessageToJson(m.systemMessage);
    return o;
}
export function upsertAISystemMessageRequestFromJson(o) {
    return {
        systemMessage: o['systemMessage'] ? aISystemMessageFromJson(o['systemMessage']) : undefined,
    };
}
export function getAISystemMessageRequestToJson(m) {
    const o = {};
    if (m.systemMessageId !== undefined)
        o['systemMessageId'] = m.systemMessageId;
    return o;
}
export function getAISystemMessageRequestFromJson(o) {
    var _a;
    return {
        systemMessageId: (_a = o['systemMessageId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getAISystemMessageResponseToJson(m) {
    const o = {};
    if (m.systemMessage !== undefined)
        o['systemMessage'] = aISystemMessageToJson(m.systemMessage);
    return o;
}
export function getAISystemMessageResponseFromJson(o) {
    return {
        systemMessage: o['systemMessage'] ? aISystemMessageFromJson(o['systemMessage']) : undefined,
    };
}
export function listAISystemMessagesRequestToJson(m) {
    const o = {};
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    return o;
}
export function listAISystemMessagesRequestFromJson(o) {
    var _a, _b;
    return {
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function listAISystemMessagesResponseToJson(m) {
    const o = {};
    if (m.aiSystemMessages !== undefined) {
        o['aiSystemMessages'] = m.aiSystemMessages.map(e => aISystemMessageToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function listAISystemMessagesResponseFromJson(o) {
    var _a, _b, _c;
    return {
        aiSystemMessages: ((_a = o['aiSystemMessages']) !== null && _a !== void 0 ? _a : []).map(e => aISystemMessageFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
    };
}
export function subjectParticipantToJson(m) {
    const o = {};
    if (m.participantType !== undefined)
        o['participantType'] = m.participantType;
    if (m.internalParticipantId !== undefined)
        o['internalParticipantId'] = m.internalParticipantId;
    return o;
}
export function subjectParticipantFromJson(o) {
    var _a, _b;
    return {
        participantType: (_a = o['participantType']) !== null && _a !== void 0 ? _a : 'GLOBAL_PARTICIPANT_TYPE_UNDEFINED',
        internalParticipantId: (_b = o['internalParticipantId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function namespaceDetailToJson(m) {
    const o = {};
    if (m.participantType !== undefined)
        o['participantType'] = m.participantType;
    if (m.internalParticipantId !== undefined)
        o['internalParticipantId'] = m.internalParticipantId;
    return o;
}
export function namespaceDetailFromJson(o) {
    var _a, _b;
    return {
        participantType: (_a = o['participantType']) !== null && _a !== void 0 ? _a : 'GLOBAL_PARTICIPANT_TYPE_UNDEFINED',
        internalParticipantId: (_b = o['internalParticipantId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function keyValuePairToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function keyValuePairFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function lastSeenByParticipantToJson(m) {
    const o = {};
    if (m.participantId !== undefined)
        o['participantId'] = m.participantId;
    if (m.lastSeenTime !== undefined)
        o['lastSeenTime'] = m.lastSeenTime.toISOString();
    return o;
}
export function lastSeenByParticipantFromJson(o) {
    var _a;
    return {
        participantId: (_a = o['participantId']) !== null && _a !== void 0 ? _a : '',
        lastSeenTime: o['lastSeenTime'] ? new Date(o['lastSeenTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function aIConfigurationToJson(m) {
    const o = {};
    if (m.aiResponseEnabled !== undefined)
        o['aiResponseEnabled'] = m.aiResponseEnabled;
    if (m.willRespondAt !== undefined)
        o['willRespondAt'] = m.willRespondAt.toISOString();
    if (m.aiResponseMode !== undefined)
        o['aiResponseMode'] = m.aiResponseMode;
    return o;
}
export function aIConfigurationFromJson(o) {
    var _a, _b;
    return {
        aiResponseEnabled: (_a = o['aiResponseEnabled']) !== null && _a !== void 0 ? _a : false,
        willRespondAt: o['willRespondAt'] ? new Date(o['willRespondAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        aiResponseMode: (_b = o['aiResponseMode']) !== null && _b !== void 0 ? _b : 'AI_RESPONSE_MODE_UNSET',
    };
}
export function latestMessageSentTimeBySubjectParticipantToJson(m) {
    const o = {};
    if (m.subjectParticipant !== undefined)
        o['subjectParticipant'] = subjectParticipantToJson(m.subjectParticipant);
    if (m.time !== undefined)
        o['time'] = m.time.toISOString();
    return o;
}
export function latestMessageSentTimeBySubjectParticipantFromJson(o) {
    return {
        subjectParticipant: o['subjectParticipant'] ? subjectParticipantFromJson(o['subjectParticipant']) : undefined,
        time: o['time'] ? new Date(o['time']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function subjectParticipantKeyToJson(m) {
    const o = {};
    if (m.subjectParticipantsKey !== undefined)
        o['subjectParticipantsKey'] = m.subjectParticipantsKey;
    if (m.subjectParticipants !== undefined) {
        o['subjectParticipants'] = m.subjectParticipants.map(e => subjectParticipantToJson(e));
    }
    return o;
}
export function subjectParticipantKeyFromJson(o) {
    var _a, _b;
    return {
        subjectParticipantsKey: (_a = o['subjectParticipantsKey']) !== null && _a !== void 0 ? _a : '',
        subjectParticipants: ((_b = o['subjectParticipants']) !== null && _b !== void 0 ? _b : []).map(e => subjectParticipantFromJson(e)),
    };
}
export function conversationToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.externalConversationId !== undefined)
        o['externalConversationId'] = m.externalConversationId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.participantIds !== undefined) {
        o['participantIds'] = m.participantIds.map(e => e);
    }
    if (m.latestMsgSentTime !== undefined)
        o['latestMsgSentTime'] = m.latestMsgSentTime.toISOString();
    if (m.originLocation !== undefined)
        o['originLocation'] = m.originLocation;
    if (m.originLocationExternalId !== undefined)
        o['originLocationExternalId'] = m.originLocationExternalId;
    if (m.lastSeenByParticipant !== undefined) {
        o['lastSeenByParticipant'] = m.lastSeenByParticipant.map(e => lastSeenByParticipantToJson(e));
    }
    if (m.conversationViewIds !== undefined) {
        o['conversationViewIds'] = m.conversationViewIds.map(e => e);
    }
    if (m.subjectParticipantsKey !== undefined)
        o['subjectParticipantsKey'] = m.subjectParticipantsKey;
    if (m.subjectParticipants !== undefined) {
        o['subjectParticipants'] = m.subjectParticipants.map(e => subjectParticipantToJson(e));
    }
    if (m.isOpen !== undefined)
        o['isOpen'] = m.isOpen;
    if (m.aiConfiguration !== undefined)
        o['aiConfiguration'] = aIConfigurationToJson(m.aiConfiguration);
    if (m.latestMsgSentTimeBySubjectParticipant !== undefined) {
        o['latestMsgSentTimeBySubjectParticipant'] = m.latestMsgSentTimeBySubjectParticipant.map(e => latestMessageSentTimeBySubjectParticipantToJson(e));
    }
    if (m.subjectParticipantKey !== undefined)
        o['subjectParticipantKey'] = subjectParticipantKeyToJson(m.subjectParticipantKey);
    if (m.latestRelevantActivityTime !== undefined)
        o['latestRelevantActivityTime'] = m.latestRelevantActivityTime.toISOString();
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    if (m.instanceId !== undefined)
        o['instanceId'] = m.instanceId;
    if (m.assigneeUserIds !== undefined) {
        o['assigneeUserIds'] = m.assigneeUserIds.map(e => e);
    }
    if (m.assigneeSource !== undefined)
        o['assigneeSource'] = m.assigneeSource;
    return o;
}
export function conversationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        channel: (_b = o['channel']) !== null && _b !== void 0 ? _b : 'CONVERSATION_CHANNEL_UNDEFINED',
        externalConversationId: (_c = o['externalConversationId']) !== null && _c !== void 0 ? _c : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        participantIds: ((_d = o['participantIds']) !== null && _d !== void 0 ? _d : []).map(e => e),
        latestMsgSentTime: o['latestMsgSentTime'] ? new Date(o['latestMsgSentTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        originLocation: (_e = o['originLocation']) !== null && _e !== void 0 ? _e : 'PLATFORM_LOCATION_UNDEFINED',
        originLocationExternalId: (_f = o['originLocationExternalId']) !== null && _f !== void 0 ? _f : '',
        lastSeenByParticipant: ((_g = o['lastSeenByParticipant']) !== null && _g !== void 0 ? _g : []).map(e => lastSeenByParticipantFromJson(e)),
        conversationViewIds: ((_h = o['conversationViewIds']) !== null && _h !== void 0 ? _h : []).map(e => e),
        subjectParticipantsKey: (_j = o['subjectParticipantsKey']) !== null && _j !== void 0 ? _j : '',
        subjectParticipants: ((_k = o['subjectParticipants']) !== null && _k !== void 0 ? _k : []).map(e => subjectParticipantFromJson(e)),
        isOpen: (_l = o['isOpen']) !== null && _l !== void 0 ? _l : false,
        aiConfiguration: o['aiConfiguration'] ? aIConfigurationFromJson(o['aiConfiguration']) : undefined,
        latestMsgSentTimeBySubjectParticipant: ((_m = o['latestMsgSentTimeBySubjectParticipant']) !== null && _m !== void 0 ? _m : []).map(e => latestMessageSentTimeBySubjectParticipantFromJson(e)),
        subjectParticipantKey: o['subjectParticipantKey'] ? subjectParticipantKeyFromJson(o['subjectParticipantKey']) : undefined,
        latestRelevantActivityTime: o['latestRelevantActivityTime'] ? new Date(o['latestRelevantActivityTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        metadata: ((_o = o['metadata']) !== null && _o !== void 0 ? _o : []).map(e => keyValuePairFromJson(e)),
        instanceId: (_p = o['instanceId']) !== null && _p !== void 0 ? _p : '',
        assigneeUserIds: ((_q = o['assigneeUserIds']) !== null && _q !== void 0 ? _q : []).map(e => e),
        assigneeSource: (_r = o['assigneeSource']) !== null && _r !== void 0 ? _r : 'ASSIGNEE_SOURCE_UNKNOWN',
    };
}
export function conversationKeyToJson(m) {
    const o = {};
    if (m.subjectParticipants !== undefined) {
        o['subjectParticipants'] = m.subjectParticipants.map(e => subjectParticipantToJson(e));
    }
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.originLocationExternalId !== undefined)
        o['originLocationExternalId'] = m.originLocationExternalId;
    return o;
}
export function conversationKeyFromJson(o) {
    var _a, _b, _c;
    return {
        subjectParticipants: ((_a = o['subjectParticipants']) !== null && _a !== void 0 ? _a : []).map(e => subjectParticipantFromJson(e)),
        channel: (_b = o['channel']) !== null && _b !== void 0 ? _b : 'CONVERSATION_CHANNEL_UNDEFINED',
        originLocationExternalId: (_c = o['originLocationExternalId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function uIButtonToJson(m) {
    const o = {};
    if (m.label !== undefined)
        o['label'] = m.label;
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.action !== undefined)
        o['action'] = m.action;
    if (m.payload !== undefined)
        o['payload'] = m.payload;
    if (m.clickedAt !== undefined)
        o['clickedAt'] = m.clickedAt.toISOString();
    return o;
}
export function uIButtonFromJson(o) {
    var _a, _b, _c, _d;
    return {
        label: (_a = o['label']) !== null && _a !== void 0 ? _a : '',
        id: (_b = o['id']) !== null && _b !== void 0 ? _b : '',
        action: (_c = o['action']) !== null && _c !== void 0 ? _c : '',
        payload: (_d = o['payload']) !== null && _d !== void 0 ? _d : '',
        clickedAt: o['clickedAt'] ? new Date(o['clickedAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function uICheckboxToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.labelText !== undefined)
        o['labelText'] = m.labelText;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.labelTranslationKey !== undefined)
        o['labelTranslationKey'] = m.labelTranslationKey;
    return o;
}
export function uICheckboxFromJson(o) {
    var _a, _b, _c, _d;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        labelText: (_b = o['labelText']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        labelTranslationKey: (_d = o['labelTranslationKey']) !== null && _d !== void 0 ? _d : '',
    };
}
export function uICheckboxGroupToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.checkboxes !== undefined) {
        o['checkboxes'] = m.checkboxes.map(e => uICheckboxToJson(e));
    }
    if (m.submitLabel !== undefined)
        o['submitLabel'] = m.submitLabel;
    if (m.submittedAt !== undefined)
        o['submittedAt'] = m.submittedAt.toISOString();
    if (m.selectedCheckboxIds !== undefined) {
        o['selectedCheckboxIds'] = m.selectedCheckboxIds.map(e => e);
    }
    return o;
}
export function uICheckboxGroupFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        title: (_b = o['title']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        checkboxes: ((_d = o['checkboxes']) !== null && _d !== void 0 ? _d : []).map(e => uICheckboxFromJson(e)),
        submitLabel: (_e = o['submitLabel']) !== null && _e !== void 0 ? _e : '',
        submittedAt: o['submittedAt'] ? new Date(o['submittedAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        selectedCheckboxIds: ((_f = o['selectedCheckboxIds']) !== null && _f !== void 0 ? _f : []).map(e => e),
    };
}
export function uIMarkdownPlanToJson(m) {
    const o = {};
    if (m.plan !== undefined)
        o['plan'] = m.plan;
    return o;
}
export function uIMarkdownPlanFromJson(o) {
    var _a;
    return {
        plan: (_a = o['plan']) !== null && _a !== void 0 ? _a : '',
    };
}
export function uIChartToJson(m) {
    const o = {};
    if (m.apexConfigJson !== undefined)
        o['apexConfigJson'] = m.apexConfigJson;
    return o;
}
export function uIChartFromJson(o) {
    var _a;
    return {
        apexConfigJson: (_a = o['apexConfigJson']) !== null && _a !== void 0 ? _a : '',
    };
}
export function uIQuestionFormToJson(m) {
    const o = {};
    if (m.questions !== undefined) {
        o['questions'] = m.questions.map(e => uIQuestionFormQuestionToJson(e));
    }
    return o;
}
export function uIQuestionFormFromJson(o) {
    var _a;
    return {
        questions: ((_a = o['questions']) !== null && _a !== void 0 ? _a : []).map(e => uIQuestionFormQuestionFromJson(e)),
    };
}
export function uIQuestionFormQuestionToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.text !== undefined)
        o['text'] = m.text;
    if (m.options !== undefined) {
        o['options'] = m.options.map(e => e);
    }
    return o;
}
export function uIQuestionFormQuestionFromJson(o) {
    var _a, _b, _c;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'UNDEFINED',
        text: (_b = o['text']) !== null && _b !== void 0 ? _b : '',
        options: ((_c = o['options']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function participantMessageStatusToJson(m) {
    const o = {};
    if (m.participantId !== undefined)
        o['participantId'] = m.participantId;
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function participantMessageStatusFromJson(o) {
    var _a, _b, _c;
    return {
        participantId: (_a = o['participantId']) !== null && _a !== void 0 ? _a : '',
        messageId: (_b = o['messageId']) !== null && _b !== void 0 ? _b : '',
        status: (_c = o['status']) !== null && _c !== void 0 ? _c : 'MESSAGE_STATUS_NOT_READ',
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function uIComponentToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.button !== undefined)
        o['button'] = uIButtonToJson(m.button);
    if (m.checkboxGroup !== undefined)
        o['checkboxGroup'] = uICheckboxGroupToJson(m.checkboxGroup);
    if (m.markdownPlan !== undefined)
        o['markdownPlan'] = uIMarkdownPlanToJson(m.markdownPlan);
    if (m.questionForm !== undefined)
        o['questionForm'] = uIQuestionFormToJson(m.questionForm);
    if (m.chart !== undefined)
        o['chart'] = uIChartToJson(m.chart);
    return o;
}
export function uIComponentFromJson(o) {
    var _a;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'UI_COMPONENT_TYPE_UNDEFINED',
        button: o['button'] ? uIButtonFromJson(o['button']) : undefined,
        checkboxGroup: o['checkboxGroup'] ? uICheckboxGroupFromJson(o['checkboxGroup']) : undefined,
        markdownPlan: o['markdownPlan'] ? uIMarkdownPlanFromJson(o['markdownPlan']) : undefined,
        questionForm: o['questionForm'] ? uIQuestionFormFromJson(o['questionForm']) : undefined,
        chart: o['chart'] ? uIChartFromJson(o['chart']) : undefined,
    };
}
export function sendStatusToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.errorCode !== undefined)
        o['errorCode'] = m.errorCode;
    return o;
}
export function sendStatusFromJson(o) {
    var _a, _b, _c;
    return {
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'MESSAGE_STATUS_NOT_READ',
        reason: (_b = o['reason']) !== null && _b !== void 0 ? _b : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        errorCode: (_c = o['errorCode']) !== null && _c !== void 0 ? _c : '',
    };
}
export function messageToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.externalMessageId !== undefined)
        o['externalMessageId'] = m.externalMessageId;
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.participantId !== undefined)
        o['participantId'] = m.participantId;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.body !== undefined)
        o['body'] = m.body;
    if (m.error !== undefined)
        o['error'] = m.error;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.media !== undefined) {
        o['media'] = m.media.map(e => e);
    }
    if (m.sendStatus !== undefined)
        o['sendStatus'] = sendStatusToJson(m.sendStatus);
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    if (m.originalContent !== undefined)
        o['originalContent'] = m.originalContent;
    if (m.uiComponents !== undefined) {
        o['uiComponents'] = m.uiComponents.map(e => uIComponentToJson(e));
    }
    if (m.aiThoughts !== undefined) {
        o['aiThoughts'] = m.aiThoughts.map(e => aIThoughtToJson(e));
    }
    if (m.aiThinkingDuration !== undefined)
        o['aiThinkingDuration'] = m.aiThinkingDuration;
    if (m.aiStatus !== undefined)
        o['aiStatus'] = m.aiStatus;
    if (m.platformLocation !== undefined)
        o['platformLocation'] = m.platformLocation;
    if (m.automationSource !== undefined)
        o['automationSource'] = m.automationSource;
    if (m.hidden !== undefined)
        o['hidden'] = m.hidden;
    return o;
}
export function messageFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
        externalMessageId: (_b = o['externalMessageId']) !== null && _b !== void 0 ? _b : '',
        conversationId: (_c = o['conversationId']) !== null && _c !== void 0 ? _c : '',
        participantId: (_d = o['participantId']) !== null && _d !== void 0 ? _d : '',
        type: (_e = o['type']) !== null && _e !== void 0 ? _e : 'MESSAGE_TYPE_MESSAGE',
        body: (_f = o['body']) !== null && _f !== void 0 ? _f : '',
        error: (_g = o['error']) !== null && _g !== void 0 ? _g : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        media: ((_h = o['media']) !== null && _h !== void 0 ? _h : []).map(e => e),
        sendStatus: o['sendStatus'] ? sendStatusFromJson(o['sendStatus']) : undefined,
        channel: (_j = o['channel']) !== null && _j !== void 0 ? _j : 'CONVERSATION_CHANNEL_UNDEFINED',
        metadata: ((_k = o['metadata']) !== null && _k !== void 0 ? _k : []).map(e => keyValuePairFromJson(e)),
        originalContent: (_l = o['originalContent']) !== null && _l !== void 0 ? _l : '',
        uiComponents: ((_m = o['uiComponents']) !== null && _m !== void 0 ? _m : []).map(e => uIComponentFromJson(e)),
        aiThoughts: ((_o = o['aiThoughts']) !== null && _o !== void 0 ? _o : []).map(e => aIThoughtFromJson(e)),
        aiThinkingDuration: (_p = o['aiThinkingDuration']) !== null && _p !== void 0 ? _p : '',
        aiStatus: (_q = o['aiStatus']) !== null && _q !== void 0 ? _q : 'AI_INVALID',
        platformLocation: (_r = o['platformLocation']) !== null && _r !== void 0 ? _r : 'PLATFORM_LOCATION_UNDEFINED',
        automationSource: (_s = o['automationSource']) !== null && _s !== void 0 ? _s : 'PLATFORM_LOCATION_UNDEFINED',
        hidden: (_t = o['hidden']) !== null && _t !== void 0 ? _t : false,
    };
}
export function addressToJson(m) {
    const o = {};
    if (m.firstLineAddress !== undefined)
        o['firstLineAddress'] = m.firstLineAddress;
    if (m.secondLineAddress !== undefined)
        o['secondLineAddress'] = m.secondLineAddress;
    if (m.city !== undefined)
        o['city'] = m.city;
    if (m.state !== undefined)
        o['state'] = m.state;
    if (m.country !== undefined)
        o['country'] = m.country;
    if (m.zipCode !== undefined)
        o['zipCode'] = m.zipCode;
    return o;
}
export function addressFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        firstLineAddress: (_a = o['firstLineAddress']) !== null && _a !== void 0 ? _a : '',
        secondLineAddress: (_b = o['secondLineAddress']) !== null && _b !== void 0 ? _b : '',
        city: (_c = o['city']) !== null && _c !== void 0 ? _c : '',
        state: (_d = o['state']) !== null && _d !== void 0 ? _d : '',
        country: (_e = o['country']) !== null && _e !== void 0 ? _e : '',
        zipCode: (_f = o['zipCode']) !== null && _f !== void 0 ? _f : '',
    };
}
export function participantToJson(m) {
    const o = {};
    if (m.participantId !== undefined)
        o['participantId'] = m.participantId;
    if (m.internalParticipantId !== undefined)
        o['internalParticipantId'] = m.internalParticipantId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.location !== undefined)
        o['location'] = m.location;
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.externalParticipantId !== undefined)
        o['externalParticipantId'] = m.externalParticipantId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.participantType !== undefined)
        o['participantType'] = m.participantType;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    if (m.address !== undefined)
        o['address'] = addressToJson(m.address);
    if (m.isSubjectParticipant !== undefined)
        o['isSubjectParticipant'] = m.isSubjectParticipant;
    if (m.isParticipantInternalInfoDeleted !== undefined)
        o['isParticipantInternalInfoDeleted'] = m.isParticipantInternalInfoDeleted;
    if (m.profileImageUrl !== undefined)
        o['profileImageUrl'] = m.profileImageUrl;
    if (m.namespaceHierarchy !== undefined) {
        o['namespaceHierarchy'] = m.namespaceHierarchy.map(e => namespaceDetailToJson(e));
    }
    return o;
}
export function participantFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return {
        participantId: (_a = o['participantId']) !== null && _a !== void 0 ? _a : '',
        internalParticipantId: (_b = o['internalParticipantId']) !== null && _b !== void 0 ? _b : '',
        partnerId: (_c = o['partnerId']) !== null && _c !== void 0 ? _c : '',
        accountGroupId: (_d = o['accountGroupId']) !== null && _d !== void 0 ? _d : '',
        location: (_e = o['location']) !== null && _e !== void 0 ? _e : 'PLATFORM_LOCATION_UNDEFINED',
        channel: (_f = o['channel']) !== null && _f !== void 0 ? _f : 'CONVERSATION_CHANNEL_UNDEFINED',
        externalParticipantId: (_g = o['externalParticipantId']) !== null && _g !== void 0 ? _g : '',
        name: (_h = o['name']) !== null && _h !== void 0 ? _h : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        participantType: (_j = o['participantType']) !== null && _j !== void 0 ? _j : 'PARTICIPANT_TYPE_UNDEFINED',
        email: (_k = o['email']) !== null && _k !== void 0 ? _k : '',
        phoneNumber: (_l = o['phoneNumber']) !== null && _l !== void 0 ? _l : '',
        address: o['address'] ? addressFromJson(o['address']) : undefined,
        isSubjectParticipant: (_m = o['isSubjectParticipant']) !== null && _m !== void 0 ? _m : false,
        isParticipantInternalInfoDeleted: (_o = o['isParticipantInternalInfoDeleted']) !== null && _o !== void 0 ? _o : false,
        profileImageUrl: (_p = o['profileImageUrl']) !== null && _p !== void 0 ? _p : '',
        namespaceHierarchy: ((_q = o['namespaceHierarchy']) !== null && _q !== void 0 ? _q : []).map(e => namespaceDetailFromJson(e)),
    };
}
export function participantKeyToJson(m) {
    const o = {};
    if (m.internalParticipantId !== undefined)
        o['internalParticipantId'] = m.internalParticipantId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.location !== undefined)
        o['location'] = m.location;
    if (m.channels !== undefined) {
        o['channels'] = m.channels.map(e => e);
    }
    if (m.participantType !== undefined)
        o['participantType'] = m.participantType;
    if (m.namespaceHierarchy !== undefined) {
        o['namespaceHierarchy'] = m.namespaceHierarchy.map(e => namespaceDetailToJson(e));
    }
    return o;
}
export function participantKeyFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        internalParticipantId: (_a = o['internalParticipantId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        accountGroupId: (_c = o['accountGroupId']) !== null && _c !== void 0 ? _c : '',
        location: (_d = o['location']) !== null && _d !== void 0 ? _d : 'PLATFORM_LOCATION_UNDEFINED',
        channels: ((_e = o['channels']) !== null && _e !== void 0 ? _e : []).map(e => e),
        participantType: (_f = o['participantType']) !== null && _f !== void 0 ? _f : 'GLOBAL_PARTICIPANT_TYPE_UNDEFINED',
        namespaceHierarchy: ((_g = o['namespaceHierarchy']) !== null && _g !== void 0 ? _g : []).map(e => namespaceDetailFromJson(e)),
    };
}
export function configurationToJson(m) {
    const o = {};
    if (m.subjectParticipant !== undefined)
        o['subjectParticipant'] = subjectParticipantToJson(m.subjectParticipant);
    if (m.createdAt !== undefined)
        o['createdAt'] = m.createdAt.toISOString();
    if (m.updatedAt !== undefined)
        o['updatedAt'] = m.updatedAt.toISOString();
    if (m.availabilityMessage !== undefined)
        o['availabilityMessage'] = m.availabilityMessage;
    if (m.showAvailabilityMessage !== undefined)
        o['showAvailabilityMessage'] = m.showAvailabilityMessage;
    if (m.googleBusinessMessagesEnabled !== undefined)
        o['googleBusinessMessagesEnabled'] = m.googleBusinessMessagesEnabled;
    if (m.smsEnabled !== undefined)
        o['smsEnabled'] = m.smsEnabled;
    if (m.inboxProEnabled !== undefined)
        o['inboxProEnabled'] = m.inboxProEnabled;
    if (m.webChatEnabled !== undefined)
        o['webChatEnabled'] = m.webChatEnabled;
    if (m.facebookMessengerEnabled !== undefined)
        o['facebookMessengerEnabled'] = m.facebookMessengerEnabled;
    if (m.multiLocationEnabled !== undefined)
        o['multiLocationEnabled'] = m.multiLocationEnabled;
    if (m.instagramMessagingEnabled !== undefined)
        o['instagramMessagingEnabled'] = m.instagramMessagingEnabled;
    if (m.aiConfiguration !== undefined)
        o['aiConfiguration'] = configurationAIConfigurationToJson(m.aiConfiguration);
    if (m.whatsappEnabled !== undefined)
        o['whatsappEnabled'] = m.whatsappEnabled;
    if (m.aiVoiceEnabled !== undefined)
        o['aiVoiceEnabled'] = m.aiVoiceEnabled;
    if (m.aiEmailEnabled !== undefined)
        o['aiEmailEnabled'] = m.aiEmailEnabled;
    if (m.aiPlatformEnabled !== undefined)
        o['aiPlatformEnabled'] = m.aiPlatformEnabled;
    if (m.emailEnabled !== undefined)
        o['emailEnabled'] = m.emailEnabled;
    return o;
}
export function configurationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        subjectParticipant: o['subjectParticipant'] ? subjectParticipantFromJson(o['subjectParticipant']) : undefined,
        createdAt: o['createdAt'] ? new Date(o['createdAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updatedAt: o['updatedAt'] ? new Date(o['updatedAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        availabilityMessage: (_a = o['availabilityMessage']) !== null && _a !== void 0 ? _a : '',
        showAvailabilityMessage: (_b = o['showAvailabilityMessage']) !== null && _b !== void 0 ? _b : false,
        googleBusinessMessagesEnabled: (_c = o['googleBusinessMessagesEnabled']) !== null && _c !== void 0 ? _c : false,
        smsEnabled: (_d = o['smsEnabled']) !== null && _d !== void 0 ? _d : false,
        inboxProEnabled: (_e = o['inboxProEnabled']) !== null && _e !== void 0 ? _e : false,
        webChatEnabled: (_f = o['webChatEnabled']) !== null && _f !== void 0 ? _f : false,
        facebookMessengerEnabled: (_g = o['facebookMessengerEnabled']) !== null && _g !== void 0 ? _g : false,
        multiLocationEnabled: (_h = o['multiLocationEnabled']) !== null && _h !== void 0 ? _h : false,
        instagramMessagingEnabled: (_j = o['instagramMessagingEnabled']) !== null && _j !== void 0 ? _j : false,
        aiConfiguration: o['aiConfiguration'] ? configurationAIConfigurationFromJson(o['aiConfiguration']) : undefined,
        whatsappEnabled: (_k = o['whatsappEnabled']) !== null && _k !== void 0 ? _k : false,
        aiVoiceEnabled: (_l = o['aiVoiceEnabled']) !== null && _l !== void 0 ? _l : false,
        aiEmailEnabled: (_m = o['aiEmailEnabled']) !== null && _m !== void 0 ? _m : false,
        aiPlatformEnabled: (_o = o['aiPlatformEnabled']) !== null && _o !== void 0 ? _o : false,
        emailEnabled: (_p = o['emailEnabled']) !== null && _p !== void 0 ? _p : false,
    };
}
export function configurationAIConfigurationToJson(m) {
    const o = {};
    if (m.smsResponderEnabled !== undefined)
        o['smsResponderEnabled'] = m.smsResponderEnabled;
    return o;
}
export function configurationAIConfigurationFromJson(o) {
    var _a;
    return {
        smsResponderEnabled: (_a = o['smsResponderEnabled']) !== null && _a !== void 0 ? _a : false,
    };
}
export function productFeatureToJson(m) {
    const o = {};
    if (m.googleBusinessMessagesEnabled !== undefined)
        o['googleBusinessMessagesEnabled'] = m.googleBusinessMessagesEnabled;
    if (m.smsEnabled !== undefined)
        o['smsEnabled'] = m.smsEnabled;
    if (m.multiLocationEnabled !== undefined)
        o['multiLocationEnabled'] = m.multiLocationEnabled;
    if (m.webChatEnabled !== undefined)
        o['webChatEnabled'] = m.webChatEnabled;
    if (m.facebookMessengerEnabled !== undefined)
        o['facebookMessengerEnabled'] = m.facebookMessengerEnabled;
    if (m.instagramMessagingEnabled !== undefined)
        o['instagramMessagingEnabled'] = m.instagramMessagingEnabled;
    if (m.aiSmsResponderEnabled !== undefined)
        o['aiSmsResponderEnabled'] = m.aiSmsResponderEnabled;
    if (m.whatsappEnabled !== undefined)
        o['whatsappEnabled'] = m.whatsappEnabled;
    if (m.aiVoiceEnabled !== undefined)
        o['aiVoiceEnabled'] = m.aiVoiceEnabled;
    if (m.aiEmailEnabled !== undefined)
        o['aiEmailEnabled'] = m.aiEmailEnabled;
    if (m.aiFacebookProductActive !== undefined)
        o['aiFacebookProductActive'] = m.aiFacebookProductActive;
    if (m.aiInstagramProductActive !== undefined)
        o['aiInstagramProductActive'] = m.aiInstagramProductActive;
    if (m.aiWhatsappProductActive !== undefined)
        o['aiWhatsappProductActive'] = m.aiWhatsappProductActive;
    if (m.aiPlatformEnabled !== undefined)
        o['aiPlatformEnabled'] = m.aiPlatformEnabled;
    if (m.emailEnabled !== undefined)
        o['emailEnabled'] = m.emailEnabled;
    return o;
}
export function productFeatureFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return {
        googleBusinessMessagesEnabled: (_a = o['googleBusinessMessagesEnabled']) !== null && _a !== void 0 ? _a : false,
        smsEnabled: (_b = o['smsEnabled']) !== null && _b !== void 0 ? _b : false,
        multiLocationEnabled: (_c = o['multiLocationEnabled']) !== null && _c !== void 0 ? _c : false,
        webChatEnabled: (_d = o['webChatEnabled']) !== null && _d !== void 0 ? _d : false,
        facebookMessengerEnabled: (_e = o['facebookMessengerEnabled']) !== null && _e !== void 0 ? _e : false,
        instagramMessagingEnabled: (_f = o['instagramMessagingEnabled']) !== null && _f !== void 0 ? _f : false,
        aiSmsResponderEnabled: (_g = o['aiSmsResponderEnabled']) !== null && _g !== void 0 ? _g : false,
        whatsappEnabled: (_h = o['whatsappEnabled']) !== null && _h !== void 0 ? _h : false,
        aiVoiceEnabled: (_j = o['aiVoiceEnabled']) !== null && _j !== void 0 ? _j : false,
        aiEmailEnabled: (_k = o['aiEmailEnabled']) !== null && _k !== void 0 ? _k : false,
        aiFacebookProductActive: (_l = o['aiFacebookProductActive']) !== null && _l !== void 0 ? _l : false,
        aiInstagramProductActive: (_m = o['aiInstagramProductActive']) !== null && _m !== void 0 ? _m : false,
        aiWhatsappProductActive: (_o = o['aiWhatsappProductActive']) !== null && _o !== void 0 ? _o : false,
        aiPlatformEnabled: (_p = o['aiPlatformEnabled']) !== null && _p !== void 0 ? _p : false,
        emailEnabled: (_q = o['emailEnabled']) !== null && _q !== void 0 ? _q : false,
    };
}
export function viewToJson(m) {
    const o = {};
    if (m.viewId !== undefined)
        o['viewId'] = m.viewId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    return o;
}
export function viewFromJson(o) {
    var _a;
    return {
        viewId: (_a = o['viewId']) !== null && _a !== void 0 ? _a : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function widgetToJson(m) {
    const o = {};
    if (m.widgetId !== undefined)
        o['widgetId'] = m.widgetId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.color !== undefined)
        o['color'] = m.color;
    if (m.allowedUrls !== undefined) {
        o['allowedUrls'] = m.allowedUrls.map(e => e);
    }
    if (m.position !== undefined)
        o['position'] = m.position;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.isEnabled !== undefined)
        o['isEnabled'] = m.isEnabled;
    if (m.welcomeMessage !== undefined)
        o['welcomeMessage'] = m.welcomeMessage;
    if (m.textColor !== undefined)
        o['textColor'] = m.textColor;
    if (m.accentColor !== undefined)
        o['accentColor'] = m.accentColor;
    if (m.accentTextColor !== undefined)
        o['accentTextColor'] = m.accentTextColor;
    if (m.skipContactCapture !== undefined)
        o['skipContactCapture'] = m.skipContactCapture;
    if (m.additionalPromptInstructions !== undefined)
        o['additionalPromptInstructions'] = m.additionalPromptInstructions;
    if (m.assistantName !== undefined)
        o['assistantName'] = m.assistantName;
    if (m.assistantAvatarUrl !== undefined)
        o['assistantAvatarUrl'] = m.assistantAvatarUrl;
    if (m.embedHistory !== undefined) {
        o['embedHistory'] = m.embedHistory.map(e => e);
    }
    if (m.hideMobileCta !== undefined)
        o['hideMobileCta'] = m.hideMobileCta;
    if (m.customGreetingMessage !== undefined)
        o['customGreetingMessage'] = m.customGreetingMessage;
    if (m.enableGreetingMessage !== undefined)
        o['enableGreetingMessage'] = m.enableGreetingMessage;
    if (m.widgetType !== undefined)
        o['widgetType'] = m.widgetType;
    if (m.assistantId !== undefined)
        o['assistantId'] = m.assistantId;
    if (m.associatedNamespaces !== undefined) {
        o['associatedNamespaces'] = m.associatedNamespaces.map(e => e);
    }
    return o;
}
export function widgetFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    return {
        widgetId: (_a = o['widgetId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        namespace: (_c = o['namespace']) !== null && _c !== void 0 ? _c : '',
        color: (_d = o['color']) !== null && _d !== void 0 ? _d : '',
        allowedUrls: ((_e = o['allowedUrls']) !== null && _e !== void 0 ? _e : []).map(e => e),
        position: (_f = o['position']) !== null && _f !== void 0 ? _f : 'WIDGET_POSITION_UNSPECIFIED',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        isEnabled: (_g = o['isEnabled']) !== null && _g !== void 0 ? _g : false,
        welcomeMessage: (_h = o['welcomeMessage']) !== null && _h !== void 0 ? _h : '',
        textColor: (_j = o['textColor']) !== null && _j !== void 0 ? _j : '',
        accentColor: (_k = o['accentColor']) !== null && _k !== void 0 ? _k : '',
        accentTextColor: (_l = o['accentTextColor']) !== null && _l !== void 0 ? _l : '',
        skipContactCapture: (_m = o['skipContactCapture']) !== null && _m !== void 0 ? _m : false,
        additionalPromptInstructions: (_o = o['additionalPromptInstructions']) !== null && _o !== void 0 ? _o : '',
        assistantName: (_p = o['assistantName']) !== null && _p !== void 0 ? _p : '',
        assistantAvatarUrl: (_q = o['assistantAvatarUrl']) !== null && _q !== void 0 ? _q : '',
        embedHistory: ((_r = o['embedHistory']) !== null && _r !== void 0 ? _r : []).map(e => e),
        hideMobileCta: (_s = o['hideMobileCta']) !== null && _s !== void 0 ? _s : false,
        customGreetingMessage: (_t = o['customGreetingMessage']) !== null && _t !== void 0 ? _t : '',
        enableGreetingMessage: (_u = o['enableGreetingMessage']) !== null && _u !== void 0 ? _u : false,
        widgetType: (_v = o['widgetType']) !== null && _v !== void 0 ? _v : '',
        assistantId: (_w = o['assistantId']) !== null && _w !== void 0 ? _w : '',
        associatedNamespaces: ((_x = o['associatedNamespaces']) !== null && _x !== void 0 ? _x : []).map(e => e),
    };
}
export function dataSourcesToJson(m) {
    const o = {};
    if (m.businessProfile !== undefined)
        o['businessProfile'] = m.businessProfile;
    if (m.businessWebsite !== undefined)
        o['businessWebsite'] = m.businessWebsite;
    return o;
}
export function dataSourcesFromJson(o) {
    var _a, _b;
    return {
        businessProfile: (_a = o['businessProfile']) !== null && _a !== void 0 ? _a : false,
        businessWebsite: (_b = o['businessWebsite']) !== null && _b !== void 0 ? _b : false,
    };
}
export function responseEvaluationToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.sentiment !== undefined)
        o['sentiment'] = m.sentiment;
    if (m.comment !== undefined)
        o['comment'] = m.comment;
    if (m.createdAt !== undefined)
        o['createdAt'] = m.createdAt.toISOString();
    if (m.subjectParticipants !== undefined) {
        o['subjectParticipants'] = m.subjectParticipants.map(e => subjectParticipantToJson(e));
    }
    if (m.eventId !== undefined)
        o['eventId'] = m.eventId;
    return o;
}
export function responseEvaluationFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
        conversationId: (_b = o['conversationId']) !== null && _b !== void 0 ? _b : '',
        sentiment: (_c = o['sentiment']) !== null && _c !== void 0 ? _c : 'EVALUATION_SENTIMENT_UNDEFINED',
        comment: (_d = o['comment']) !== null && _d !== void 0 ? _d : '',
        createdAt: o['createdAt'] ? new Date(o['createdAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        subjectParticipants: ((_e = o['subjectParticipants']) !== null && _e !== void 0 ? _e : []).map(e => subjectParticipantFromJson(e)),
        eventId: (_f = o['eventId']) !== null && _f !== void 0 ? _f : '',
    };
}
export function messageTemplateToJson(m) {
    const o = {};
    if (m.templateId !== undefined)
        o['templateId'] = m.templateId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    return o;
}
export function messageTemplateFromJson(o) {
    var _a, _b, _c;
    return {
        templateId: (_a = o['templateId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        content: (_c = o['content']) !== null && _c !== void 0 ? _c : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function generateDraftPreviewRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.replyToMessageId !== undefined)
        o['replyToMessageId'] = m.replyToMessageId;
    return o;
}
export function generateDraftPreviewRequestFromJson(o) {
    var _a, _b;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        replyToMessageId: (_b = o['replyToMessageId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function generateDraftPreviewResponseToJson(m) {
    const o = {};
    if (m.draftText !== undefined)
        o['draftText'] = m.draftText;
    if (m.aiModel !== undefined)
        o['aiModel'] = m.aiModel;
    if (m.generationId !== undefined)
        o['generationId'] = m.generationId;
    return o;
}
export function generateDraftPreviewResponseFromJson(o) {
    var _a, _b, _c;
    return {
        draftText: (_a = o['draftText']) !== null && _a !== void 0 ? _a : '',
        aiModel: (_b = o['aiModel']) !== null && _b !== void 0 ? _b : '',
        generationId: (_c = o['generationId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function sendMessageDraftRequestToJson(m) {
    const o = {};
    if (m.draftId !== undefined)
        o['draftId'] = m.draftId;
    if (m.editedText !== undefined)
        o['editedText'] = m.editedText;
    return o;
}
export function sendMessageDraftRequestFromJson(o) {
    var _a, _b;
    return {
        draftId: (_a = o['draftId']) !== null && _a !== void 0 ? _a : '',
        editedText: (_b = o['editedText']) !== null && _b !== void 0 ? _b : '',
    };
}
export function sendMessageDraftResponseToJson(m) {
    const o = {};
    return o;
}
export function sendMessageDraftResponseFromJson(o) {
    return {};
}
export function discardMessageDraftRequestToJson(m) {
    const o = {};
    if (m.draftId !== undefined)
        o['draftId'] = m.draftId;
    if (m.disposition !== undefined)
        o['disposition'] = m.disposition;
    return o;
}
export function discardMessageDraftRequestFromJson(o) {
    var _a, _b;
    return {
        draftId: (_a = o['draftId']) !== null && _a !== void 0 ? _a : '',
        disposition: (_b = o['disposition']) !== null && _b !== void 0 ? _b : 'DRAFT_DISPOSITION_UNSPECIFIED',
    };
}
export function discardMessageDraftResponseToJson(m) {
    const o = {};
    return o;
}
export function discardMessageDraftResponseFromJson(o) {
    return {};
}
export function messageDraftToJson(m) {
    const o = {};
    if (m.draftId !== undefined)
        o['draftId'] = m.draftId;
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.sourceMessageId !== undefined)
        o['sourceMessageId'] = m.sourceMessageId;
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.lifecycleState !== undefined)
        o['lifecycleState'] = m.lifecycleState;
    if (m.emailTrackedMessageId !== undefined)
        o['emailTrackedMessageId'] = m.emailTrackedMessageId;
    if (m.body !== undefined)
        o['body'] = m.body;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function messageDraftFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        draftId: (_a = o['draftId']) !== null && _a !== void 0 ? _a : '',
        conversationId: (_b = o['conversationId']) !== null && _b !== void 0 ? _b : '',
        sourceMessageId: (_c = o['sourceMessageId']) !== null && _c !== void 0 ? _c : '',
        channel: (_d = o['channel']) !== null && _d !== void 0 ? _d : 'CONVERSATION_CHANNEL_UNDEFINED',
        lifecycleState: (_e = o['lifecycleState']) !== null && _e !== void 0 ? _e : 'MESSAGE_DRAFT_LIFECYCLE_STATE_UNSPECIFIED',
        emailTrackedMessageId: (_f = o['emailTrackedMessageId']) !== null && _f !== void 0 ? _f : '',
        body: (_g = o['body']) !== null && _g !== void 0 ? _g : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function listMessageDraftsRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.lifecycleState !== undefined)
        o['lifecycleState'] = m.lifecycleState;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listMessageDraftsRequestFromJson(o) {
    var _a, _b;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        lifecycleState: (_b = o['lifecycleState']) !== null && _b !== void 0 ? _b : 'MESSAGE_DRAFT_LIFECYCLE_STATE_UNSPECIFIED',
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listMessageDraftsResponseToJson(m) {
    const o = {};
    if (m.messageDrafts !== undefined) {
        o['messageDrafts'] = m.messageDrafts.map(e => messageDraftToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listMessageDraftsResponseFromJson(o) {
    var _a;
    return {
        messageDrafts: ((_a = o['messageDrafts']) !== null && _a !== void 0 ? _a : []).map(e => messageDraftFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function getMultiMessageDraftRequestToJson(m) {
    const o = {};
    if (m.draftIds !== undefined) {
        o['draftIds'] = m.draftIds.map(e => e);
    }
    return o;
}
export function getMultiMessageDraftRequestFromJson(o) {
    var _a;
    return {
        draftIds: ((_a = o['draftIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getMultiMessageDraftResponseToJson(m) {
    const o = {};
    if (m.messageDrafts !== undefined) {
        o['messageDrafts'] = m.messageDrafts.map(e => messageDraftToJson(e));
    }
    return o;
}
export function getMultiMessageDraftResponseFromJson(o) {
    var _a;
    return {
        messageDrafts: ((_a = o['messageDrafts']) !== null && _a !== void 0 ? _a : []).map(e => messageDraftFromJson(e)),
    };
}
export function eventToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.eventId !== undefined)
        o['eventId'] = m.eventId;
    if (m.happenedAt !== undefined)
        o['happenedAt'] = m.happenedAt.toISOString();
    if (m.labelKey !== undefined)
        o['labelKey'] = m.labelKey;
    if (m.initiatorId !== undefined)
        o['initiatorId'] = m.initiatorId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.message !== undefined)
        o['message'] = m.message;
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.originatedAt !== undefined)
        o['originatedAt'] = m.originatedAt;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    return o;
}
export function eventFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        eventId: (_b = o['eventId']) !== null && _b !== void 0 ? _b : '',
        happenedAt: o['happenedAt'] ? new Date(o['happenedAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        labelKey: (_c = o['labelKey']) !== null && _c !== void 0 ? _c : '',
        initiatorId: (_d = o['initiatorId']) !== null && _d !== void 0 ? _d : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        message: (_e = o['message']) !== null && _e !== void 0 ? _e : '',
        channel: (_f = o['channel']) !== null && _f !== void 0 ? _f : 'CONVERSATION_CHANNEL_UNDEFINED',
        originatedAt: (_g = o['originatedAt']) !== null && _g !== void 0 ? _g : 'PLATFORM_LOCATION_UNDEFINED',
        type: (_h = o['type']) !== null && _h !== void 0 ? _h : 'EVENT_TYPE_UNDEFINED',
        metadata: ((_j = o['metadata']) !== null && _j !== void 0 ? _j : []).map(e => keyValuePairFromJson(e)),
    };
}
export function filtersToJson(m) {
    const o = {};
    if (m.startTime !== undefined)
        o['startTime'] = m.startTime.toISOString();
    if (m.endTime !== undefined)
        o['endTime'] = m.endTime.toISOString();
    return o;
}
export function filtersFromJson(o) {
    return {
        startTime: o['startTime'] ? new Date(o['startTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        endTime: o['endTime'] ? new Date(o['endTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function conversationExportRecordToJson(m) {
    const o = {};
    if (m.requestId !== undefined)
        o['requestId'] = m.requestId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.subjectParticipant !== undefined)
        o['subjectParticipant'] = subjectParticipantToJson(m.subjectParticipant);
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    if (m.filters !== undefined)
        o['filters'] = filtersToJson(m.filters);
    if (m.errorCode !== undefined)
        o['errorCode'] = m.errorCode;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.fileName !== undefined)
        o['fileName'] = m.fileName;
    return o;
}
export function conversationExportRecordFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        requestId: (_a = o['requestId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        subjectParticipant: o['subjectParticipant'] ? subjectParticipantFromJson(o['subjectParticipant']) : undefined,
        status: (_c = o['status']) !== null && _c !== void 0 ? _c : 'EXPORT_STATUS_UNDEFINED',
        recipientEmail: (_d = o['recipientEmail']) !== null && _d !== void 0 ? _d : '',
        filters: o['filters'] ? filtersFromJson(o['filters']) : undefined,
        errorCode: (_e = o['errorCode']) !== null && _e !== void 0 ? _e : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        fileName: (_f = o['fileName']) !== null && _f !== void 0 ? _f : '',
    };
}
export function pagedRequestOptionsToJson(m) {
    const o = {};
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    return o;
}
export function pagedRequestOptionsFromJson(o) {
    var _a, _b;
    return {
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function pagedResponseMetadataToJson(m) {
    const o = {};
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.totalResults !== undefined)
        o['totalResults'] = m.totalResults;
    return o;
}
export function pagedResponseMetadataFromJson(o) {
    var _a, _b, _c;
    return {
        nextCursor: (_a = o['nextCursor']) !== null && _a !== void 0 ? _a : '',
        hasMore: (_b = o['hasMore']) !== null && _b !== void 0 ? _b : false,
        totalResults: (_c = o['totalResults']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function metadataToJson(m) {
    const o = {};
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    if (m.data !== undefined) {
        const map = {};
        for (const [k, v] of Object.entries(m.data)) {
            map[k] = v;
        }
        o['data'] = map;
    }
    return o;
}
export function metadataFromJson(o) {
    var _a;
    return {
        identifier: (_a = o['identifier']) !== null && _a !== void 0 ? _a : 'METADATA_IDENTIFIER_UNDEFINED',
        data: o['data']
            ? Object.fromEntries(Object.entries(o['data']).map(([k, v]) => [k, v]))
            : {},
    };
}
export function sendMessageRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = participantToJson(m.sender);
    if (m.recipient !== undefined)
        o['recipient'] = participantToJson(m.recipient);
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.body !== undefined)
        o['body'] = m.body;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => metadataToJson(e));
    }
    if (m.originLocation !== undefined)
        o['originLocation'] = m.originLocation;
    if (m.media !== undefined) {
        o['media'] = m.media.map(e => mediaToJson(e));
    }
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.options !== undefined)
        o['options'] = sendMessageOptionsToJson(m.options);
    return o;
}
export function sendMessageRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        sender: o['sender'] ? participantFromJson(o['sender']) : undefined,
        recipient: o['recipient'] ? participantFromJson(o['recipient']) : undefined,
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        type: (_b = o['type']) !== null && _b !== void 0 ? _b : 'MESSAGE_TYPE_MESSAGE',
        body: (_c = o['body']) !== null && _c !== void 0 ? _c : '',
        metadata: ((_d = o['metadata']) !== null && _d !== void 0 ? _d : []).map(e => metadataFromJson(e)),
        originLocation: (_e = o['originLocation']) !== null && _e !== void 0 ? _e : 'PLATFORM_LOCATION_UNDEFINED',
        media: ((_f = o['media']) !== null && _f !== void 0 ? _f : []).map(e => mediaFromJson(e)),
        channel: (_g = o['channel']) !== null && _g !== void 0 ? _g : 'CONVERSATION_CHANNEL_UNDEFINED',
        options: o['options'] ? sendMessageOptionsFromJson(o['options']) : undefined,
    };
}
export function sendMessageOptionsToJson(m) {
    const o = {};
    if (m.runSync !== undefined)
        o['runSync'] = m.runSync;
    if (m.skipMessageDelivery !== undefined)
        o['skipMessageDelivery'] = m.skipMessageDelivery;
    if (m.aiMode !== undefined)
        o['aiMode'] = m.aiMode;
    return o;
}
export function sendMessageOptionsFromJson(o) {
    var _a, _b, _c;
    return {
        runSync: (_a = o['runSync']) !== null && _a !== void 0 ? _a : false,
        skipMessageDelivery: (_b = o['skipMessageDelivery']) !== null && _b !== void 0 ? _b : false,
        aiMode: (_c = o['aiMode']) !== null && _c !== void 0 ? _c : 'AI_MODE_UNSET',
    };
}
export function mediaToJson(m) {
    const o = {};
    if (m.mediaContentType !== undefined)
        o['mediaContentType'] = m.mediaContentType;
    if (m.mediaLocationPath !== undefined)
        o['mediaLocationPath'] = m.mediaLocationPath;
    if (m.mediaFileName !== undefined)
        o['mediaFileName'] = m.mediaFileName;
    if (m.fileSize !== undefined)
        o['fileSize'] = m.fileSize;
    if (m.mediaUrl !== undefined)
        o['mediaUrl'] = m.mediaUrl;
    if (m.transcodingJobId !== undefined)
        o['transcodingJobId'] = m.transcodingJobId;
    if (m.transcodedUrl !== undefined)
        o['transcodedUrl'] = m.transcodedUrl;
    return o;
}
export function mediaFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        mediaContentType: (_a = o['mediaContentType']) !== null && _a !== void 0 ? _a : '',
        mediaLocationPath: (_b = o['mediaLocationPath']) !== null && _b !== void 0 ? _b : '',
        mediaFileName: (_c = o['mediaFileName']) !== null && _c !== void 0 ? _c : '',
        fileSize: (_d = o['fileSize']) !== null && _d !== void 0 ? _d : 0,
        mediaUrl: (_e = o['mediaUrl']) !== null && _e !== void 0 ? _e : '',
        transcodingJobId: (_f = o['transcodingJobId']) !== null && _f !== void 0 ? _f : '',
        transcodedUrl: (_g = o['transcodedUrl']) !== null && _g !== void 0 ? _g : '',
    };
}
export function getMessageOptionsToJson(m) {
    const o = {};
    if (m.includeOriginalContent !== undefined)
        o['includeOriginalContent'] = m.includeOriginalContent;
    return o;
}
export function getMessageOptionsFromJson(o) {
    var _a;
    return {
        includeOriginalContent: (_a = o['includeOriginalContent']) !== null && _a !== void 0 ? _a : false,
    };
}
export function getMessageRequestToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.options !== undefined)
        o['options'] = getMessageOptionsToJson(m.options);
    return o;
}
export function getMessageRequestFromJson(o) {
    var _a;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
        options: o['options'] ? getMessageOptionsFromJson(o['options']) : undefined,
    };
}
export function deleteMessageRequestToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    return o;
}
export function deleteMessageRequestFromJson(o) {
    var _a;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function hideMessageRequestToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    return o;
}
export function hideMessageRequestFromJson(o) {
    var _a;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listMessagesRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listMessagesRequestListMessagesFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listMessagesRequestFromJson(o) {
    return {
        filters: o['filters'] ? listMessagesRequestListMessagesFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listMessagesRequestListMessagesFiltersToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function listMessagesRequestListMessagesFiltersFromJson(o) {
    var _a;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateMessageStatusRequestToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.participantId !== undefined)
        o['participantId'] = m.participantId;
    if (m.status !== undefined)
        o['status'] = m.status;
    return o;
}
export function updateMessageStatusRequestFromJson(o) {
    var _a, _b, _c;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
        participantId: (_b = o['participantId']) !== null && _b !== void 0 ? _b : '',
        status: (_c = o['status']) !== null && _c !== void 0 ? _c : 'MESSAGE_STATUS_NOT_READ',
    };
}
export function createAsyncJobMessageRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.processingJobId !== undefined)
        o['processingJobId'] = m.processingJobId;
    if (m.body !== undefined)
        o['body'] = m.body;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    return o;
}
export function createAsyncJobMessageRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        processingJobId: (_b = o['processingJobId']) !== null && _b !== void 0 ? _b : '',
        body: (_c = o['body']) !== null && _c !== void 0 ? _c : '',
        metadata: ((_d = o['metadata']) !== null && _d !== void 0 ? _d : []).map(e => keyValuePairFromJson(e)),
    };
}
export function createAsyncJobMessageResponseToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    return o;
}
export function createAsyncJobMessageResponseFromJson(o) {
    var _a;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateAsyncJobMessageRequestToJson(m) {
    const o = {};
    if (m.processingJobId !== undefined)
        o['processingJobId'] = m.processingJobId;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    if (m.media !== undefined) {
        o['media'] = m.media.map(e => mediaToJson(e));
    }
    if (m.body !== undefined)
        o['body'] = m.body;
    if (m.updateMask !== undefined)
        o['updateMask'] = fieldMaskToJson(m.updateMask);
    return o;
}
export function updateAsyncJobMessageRequestFromJson(o) {
    var _a, _b, _c;
    return {
        processingJobId: (_a = o['processingJobId']) !== null && _a !== void 0 ? _a : '',
        metadata: ((_b = o['metadata']) !== null && _b !== void 0 ? _b : []).map(e => keyValuePairFromJson(e)),
        media: ((_c = o['media']) !== null && _c !== void 0 ? _c : []).map(e => mediaFromJson(e)),
        body: o['body'],
        updateMask: o['updateMask'] ? fieldMaskFromJson(o['updateMask']) : undefined,
    };
}
export function lookupConversationsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = lookupConversationsRequestLookupConversationsFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function lookupConversationsRequestFromJson(o) {
    return {
        filters: o['filters'] ? lookupConversationsRequestLookupConversationsFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function lookupConversationsRequestLookupConversationsFiltersToJson(m) {
    const o = {};
    if (m.internalParticipantId !== undefined) {
        o['internalParticipantId'] = m.internalParticipantId.map(e => e);
    }
    if (m.location !== undefined)
        o['location'] = m.location;
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.externalConversationId !== undefined)
        o['externalConversationId'] = m.externalConversationId;
    if (m.originLocation !== undefined)
        o['originLocation'] = m.originLocation;
    if (m.originLocationExternalId !== undefined)
        o['originLocationExternalId'] = m.originLocationExternalId;
    return o;
}
export function lookupConversationsRequestLookupConversationsFiltersFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        internalParticipantId: ((_a = o['internalParticipantId']) !== null && _a !== void 0 ? _a : []).map(e => e),
        location: (_b = o['location']) !== null && _b !== void 0 ? _b : 'PLATFORM_LOCATION_UNDEFINED',
        channel: (_c = o['channel']) !== null && _c !== void 0 ? _c : 'CONVERSATION_CHANNEL_UNDEFINED',
        accountGroupId: (_d = o['accountGroupId']) !== null && _d !== void 0 ? _d : '',
        externalConversationId: (_e = o['externalConversationId']) !== null && _e !== void 0 ? _e : '',
        originLocation: (_f = o['originLocation']) !== null && _f !== void 0 ? _f : 'PLATFORM_LOCATION_UNDEFINED',
        originLocationExternalId: (_g = o['originLocationExternalId']) !== null && _g !== void 0 ? _g : '',
    };
}
export function getConversationByKeyRequestToJson(m) {
    const o = {};
    if (m.conversationKey !== undefined)
        o['conversationKey'] = conversationKeyToJson(m.conversationKey);
    return o;
}
export function getConversationByKeyRequestFromJson(o) {
    return {
        conversationKey: o['conversationKey'] ? conversationKeyFromJson(o['conversationKey']) : undefined,
    };
}
export function createConversationRequestToJson(m) {
    const o = {};
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => participantToJson(e));
    }
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.externalConversationId !== undefined)
        o['externalConversationId'] = m.externalConversationId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.originLocation !== undefined)
        o['originLocation'] = m.originLocation;
    if (m.originLocationExternalId !== undefined)
        o['originLocationExternalId'] = m.originLocationExternalId;
    if (m.instanceId !== undefined)
        o['instanceId'] = m.instanceId;
    return o;
}
export function createConversationRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        participants: ((_a = o['participants']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
        channel: (_b = o['channel']) !== null && _b !== void 0 ? _b : 'CONVERSATION_CHANNEL_UNDEFINED',
        externalConversationId: (_c = o['externalConversationId']) !== null && _c !== void 0 ? _c : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        originLocation: (_d = o['originLocation']) !== null && _d !== void 0 ? _d : 'PLATFORM_LOCATION_UNDEFINED',
        originLocationExternalId: (_e = o['originLocationExternalId']) !== null && _e !== void 0 ? _e : '',
        instanceId: (_f = o['instanceId']) !== null && _f !== void 0 ? _f : '',
    };
}
export function updateConversationRequestToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateConversationRequestFromJson(o) {
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function updateConversationResponseToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    return o;
}
export function updateConversationResponseFromJson(o) {
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
    };
}
export function cancelAIResponderRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function cancelAIResponderRequestFromJson(o) {
    var _a;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function deleteConversationRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function deleteConversationRequestFromJson(o) {
    var _a;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function receiveMessageRequestToJson(m) {
    const o = {};
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.recipientId !== undefined)
        o['recipientId'] = m.recipientId;
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.body !== undefined)
        o['body'] = m.body;
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.location !== undefined)
        o['location'] = m.location;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.metadata !== undefined) {
        const map = {};
        for (const [k, v] of Object.entries(m.metadata)) {
            map[k] = v;
        }
        o['metadata'] = map;
    }
    if (m.media !== undefined) {
        o['media'] = m.media.map(e => e);
    }
    if (m.namespace !== undefined)
        o['namespace'] = namespaceDetailToJson(m.namespace);
    return o;
}
export function receiveMessageRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return {
        senderId: (_a = o['senderId']) !== null && _a !== void 0 ? _a : '',
        recipientId: (_b = o['recipientId']) !== null && _b !== void 0 ? _b : '',
        conversationId: (_c = o['conversationId']) !== null && _c !== void 0 ? _c : '',
        messageId: (_d = o['messageId']) !== null && _d !== void 0 ? _d : '',
        body: (_e = o['body']) !== null && _e !== void 0 ? _e : '',
        channel: (_f = o['channel']) !== null && _f !== void 0 ? _f : 'CONVERSATION_CHANNEL_UNDEFINED',
        type: (_g = o['type']) !== null && _g !== void 0 ? _g : 'MESSAGE_TYPE_MESSAGE',
        location: (_h = o['location']) !== null && _h !== void 0 ? _h : 'PLATFORM_LOCATION_UNDEFINED',
        partnerId: (_j = o['partnerId']) !== null && _j !== void 0 ? _j : '',
        accountGroupId: (_k = o['accountGroupId']) !== null && _k !== void 0 ? _k : '',
        metadata: o['metadata']
            ? Object.fromEntries(Object.entries(o['metadata']).map(([k, v]) => [k, v]))
            : {},
        media: ((_l = o['media']) !== null && _l !== void 0 ? _l : []).map(e => e),
        namespace: o['namespace'] ? namespaceDetailFromJson(o['namespace']) : undefined,
    };
}
export function getMultiMessagesRequestToJson(m) {
    const o = {};
    if (m.messageIds !== undefined) {
        o['messageIds'] = m.messageIds.map(e => e);
    }
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.languageCode !== undefined)
        o['languageCode'] = m.languageCode;
    return o;
}
export function getMultiMessagesRequestFromJson(o) {
    var _a, _b, _c;
    return {
        messageIds: ((_a = o['messageIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        conversationId: (_b = o['conversationId']) !== null && _b !== void 0 ? _b : '',
        languageCode: (_c = o['languageCode']) !== null && _c !== void 0 ? _c : '',
    };
}
export function createMultiMessagesRequestToJson(m) {
    const o = {};
    if (m.messages !== undefined) {
        o['messages'] = m.messages.map(e => messageToJson(e));
    }
    if (m.lastSeen !== undefined)
        o['lastSeen'] = m.lastSeen.toISOString();
    return o;
}
export function createMultiMessagesRequestFromJson(o) {
    var _a;
    return {
        messages: ((_a = o['messages']) !== null && _a !== void 0 ? _a : []).map(e => messageFromJson(e)),
        lastSeen: o['lastSeen'] ? new Date(o['lastSeen']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function getMultiConversationDetailsOptionsToJson(m) {
    const o = {};
    if (m.disableParticipantBranding !== undefined)
        o['disableParticipantBranding'] = m.disableParticipantBranding;
    if (m.exclusions !== undefined)
        o['exclusions'] = fieldMaskToJson(m.exclusions);
    if (m.disableParticipantHydration !== undefined)
        o['disableParticipantHydration'] = m.disableParticipantHydration;
    return o;
}
export function getMultiConversationDetailsOptionsFromJson(o) {
    var _a, _b;
    return {
        disableParticipantBranding: (_a = o['disableParticipantBranding']) !== null && _a !== void 0 ? _a : false,
        exclusions: o['exclusions'] ? fieldMaskFromJson(o['exclusions']) : undefined,
        disableParticipantHydration: (_b = o['disableParticipantHydration']) !== null && _b !== void 0 ? _b : false,
    };
}
export function getMultiConversationDetailsRequestToJson(m) {
    const o = {};
    if (m.conversationIds !== undefined) {
        o['conversationIds'] = m.conversationIds.map(e => e);
    }
    if (m.options !== undefined)
        o['options'] = fieldMaskToJson(m.options);
    return o;
}
export function getMultiConversationDetailsRequestFromJson(o) {
    var _a;
    return {
        conversationIds: ((_a = o['conversationIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        options: o['options'] ? fieldMaskFromJson(o['options']) : undefined,
    };
}
export function getMultiConversationDetailsV2RequestToJson(m) {
    const o = {};
    if (m.conversationIds !== undefined) {
        o['conversationIds'] = m.conversationIds.map(e => e);
    }
    if (m.exclusions !== undefined)
        o['exclusions'] = fieldMaskToJson(m.exclusions);
    if (m.options !== undefined)
        o['options'] = getMultiConversationDetailsOptionsToJson(m.options);
    return o;
}
export function getMultiConversationDetailsV2RequestFromJson(o) {
    var _a;
    return {
        conversationIds: ((_a = o['conversationIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        exclusions: o['exclusions'] ? fieldMaskFromJson(o['exclusions']) : undefined,
        options: o['options'] ? getMultiConversationDetailsOptionsFromJson(o['options']) : undefined,
    };
}
export function getMultiParticipantsRequestToJson(m) {
    const o = {};
    if (m.participantIds !== undefined) {
        o['participantIds'] = m.participantIds.map(e => e);
    }
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function getMultiParticipantsRequestFromJson(o) {
    var _a, _b;
    return {
        participantIds: ((_a = o['participantIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        conversationId: (_b = o['conversationId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function setLastSeenRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.participant !== undefined)
        o['participant'] = participantToJson(m.participant);
    if (m.status !== undefined)
        o['status'] = m.status;
    return o;
}
export function setLastSeenRequestFromJson(o) {
    var _a, _b;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        participant: o['participant'] ? participantFromJson(o['participant']) : undefined,
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'SET_LAST_SEEN_REQUEST_STATUS_READ',
    };
}
export function getParticipantsByKeyRequestToJson(m) {
    const o = {};
    if (m.participantKey !== undefined)
        o['participantKey'] = participantKeyToJson(m.participantKey);
    return o;
}
export function getParticipantsByKeyRequestFromJson(o) {
    return {
        participantKey: o['participantKey'] ? participantKeyFromJson(o['participantKey']) : undefined,
    };
}
export function injectMessageRequestToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.body !== undefined)
        o['body'] = m.body;
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.location !== undefined)
        o['location'] = m.location;
    if (m.metadata !== undefined) {
        const map = {};
        for (const [k, v] of Object.entries(m.metadata)) {
            map[k] = v;
        }
        o['metadata'] = map;
    }
    if (m.media !== undefined) {
        o['media'] = m.media.map(e => mediaToJson(e));
    }
    if (m.namespace !== undefined)
        o['namespace'] = namespaceDetailToJson(m.namespace);
    if (m.sourceName !== undefined)
        o['sourceName'] = m.sourceName;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    return o;
}
export function injectMessageRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
        body: (_b = o['body']) !== null && _b !== void 0 ? _b : '',
        channel: (_c = o['channel']) !== null && _c !== void 0 ? _c : 'CONVERSATION_CHANNEL_UNDEFINED',
        type: (_d = o['type']) !== null && _d !== void 0 ? _d : 'MESSAGE_TYPE_MESSAGE',
        location: (_e = o['location']) !== null && _e !== void 0 ? _e : 'PLATFORM_LOCATION_UNDEFINED',
        metadata: o['metadata']
            ? Object.fromEntries(Object.entries(o['metadata']).map(([k, v]) => [k, v]))
            : {},
        media: ((_f = o['media']) !== null && _f !== void 0 ? _f : []).map(e => mediaFromJson(e)),
        namespace: o['namespace'] ? namespaceDetailFromJson(o['namespace']) : undefined,
        sourceName: (_g = o['sourceName']) !== null && _g !== void 0 ? _g : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function listMessagesResponseToJson(m) {
    const o = {};
    if (m.messages !== undefined) {
        o['messages'] = m.messages.map(e => messageToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listMessagesResponseFromJson(o) {
    var _a;
    return {
        messages: ((_a = o['messages']) !== null && _a !== void 0 ? _a : []).map(e => messageFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function lookupConversationsResponseToJson(m) {
    const o = {};
    if (m.conversations !== undefined) {
        o['conversations'] = m.conversations.map(e => lookupConversationsResponseConversationsToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function lookupConversationsResponseFromJson(o) {
    var _a;
    return {
        conversations: ((_a = o['conversations']) !== null && _a !== void 0 ? _a : []).map(e => lookupConversationsResponseConversationsFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function lookupConversationsResponseConversationsToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => participantToJson(e));
    }
    return o;
}
export function lookupConversationsResponseConversationsFromJson(o) {
    var _a;
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
        participants: ((_a = o['participants']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
    };
}
export function getConversationByKeyResponseToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    return o;
}
export function getConversationByKeyResponseFromJson(o) {
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
    };
}
export function createConversationResponseToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => participantToJson(e));
    }
    return o;
}
export function createConversationResponseFromJson(o) {
    var _a;
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
        participants: ((_a = o['participants']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
    };
}
export function sendMessageResponseToJson(m) {
    const o = {};
    if (m.workflowId !== undefined)
        o['workflowId'] = m.workflowId;
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function sendMessageResponseFromJson(o) {
    var _a, _b, _c;
    return {
        workflowId: (_a = o['workflowId']) !== null && _a !== void 0 ? _a : '',
        messageId: (_b = o['messageId']) !== null && _b !== void 0 ? _b : '',
        conversationId: (_c = o['conversationId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getMultiMessagesResponseToJson(m) {
    const o = {};
    if (m.messages !== undefined) {
        o['messages'] = m.messages.map(e => messageToJson(e));
    }
    return o;
}
export function getMultiMessagesResponseFromJson(o) {
    var _a;
    return {
        messages: ((_a = o['messages']) !== null && _a !== void 0 ? _a : []).map(e => messageFromJson(e)),
    };
}
export function getMultiConversationDetailsResponseToJson(m) {
    const o = {};
    if (m.conversations !== undefined) {
        o['conversations'] = m.conversations.map(e => getMultiConversationDetailsResponseDetailedConversationToJson(e));
    }
    return o;
}
export function getMultiConversationDetailsResponseFromJson(o) {
    var _a;
    return {
        conversations: ((_a = o['conversations']) !== null && _a !== void 0 ? _a : []).map(e => getMultiConversationDetailsResponseDetailedConversationFromJson(e)),
    };
}
export function getMultiConversationDetailsResponseDetailedConversationToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    if (m.latestMessage !== undefined)
        o['latestMessage'] = messageToJson(m.latestMessage);
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => participantToJson(e));
    }
    if (m.summary !== undefined)
        o['summary'] = m.summary;
    if (m.latestRelevantActivity !== undefined) {
        if (m.latestRelevantActivity.type === 'event') {
            o['event'] = eventToJson(m.latestRelevantActivity.event);
        }
        if (m.latestRelevantActivity.type === 'message') {
            o['message'] = messageToJson(m.latestRelevantActivity.message);
        }
    }
    else {
        if (m.event !== undefined)
            o['event'] = eventToJson(m.event);
        if (m.message !== undefined)
            o['message'] = messageToJson(m.message);
    }
    return o;
}
export function getMultiConversationDetailsResponseDetailedConversationFromJson(o) {
    var _a, _b;
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
        latestMessage: o['latestMessage'] ? messageFromJson(o['latestMessage']) : undefined,
        participants: ((_a = o['participants']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
        summary: (_b = o['summary']) !== null && _b !== void 0 ? _b : '',
        latestRelevantActivity: (() => {
            if (o['event'] !== undefined)
                return { type: 'event', event: o['event'] ? eventFromJson(o['event']) : undefined };
            if (o['message'] !== undefined)
                return { type: 'message', message: o['message'] ? messageFromJson(o['message']) : undefined };
            return undefined;
        })(),
        event: o['event'] !== undefined ? o['event'] ? eventFromJson(o['event']) : undefined : undefined,
        message: o['message'] !== undefined ? o['message'] ? messageFromJson(o['message']) : undefined : undefined,
    };
}
export function getMultiConversationDetailsV2ResponseToJson(m) {
    const o = {};
    if (m.conversations !== undefined) {
        o['conversations'] = m.conversations.map(e => getMultiConversationDetailsV2ResponseDetailedConversationToJson(e));
    }
    return o;
}
export function getMultiConversationDetailsV2ResponseFromJson(o) {
    var _a;
    return {
        conversations: ((_a = o['conversations']) !== null && _a !== void 0 ? _a : []).map(e => getMultiConversationDetailsV2ResponseDetailedConversationFromJson(e)),
    };
}
export function getMultiConversationDetailsV2ResponseDetailedConversationToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => participantToJson(e));
    }
    if (m.summary !== undefined)
        o['summary'] = m.summary;
    if (m.latestRelevantActivity !== undefined) {
        if (m.latestRelevantActivity.type === 'event') {
            o['event'] = eventToJson(m.latestRelevantActivity.event);
        }
        if (m.latestRelevantActivity.type === 'message') {
            o['message'] = messageToJson(m.latestRelevantActivity.message);
        }
    }
    else {
        if (m.event !== undefined)
            o['event'] = eventToJson(m.event);
        if (m.message !== undefined)
            o['message'] = messageToJson(m.message);
    }
    return o;
}
export function getMultiConversationDetailsV2ResponseDetailedConversationFromJson(o) {
    var _a, _b;
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
        participants: ((_a = o['participants']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
        summary: (_b = o['summary']) !== null && _b !== void 0 ? _b : '',
        latestRelevantActivity: (() => {
            if (o['event'] !== undefined)
                return { type: 'event', event: o['event'] ? eventFromJson(o['event']) : undefined };
            if (o['message'] !== undefined)
                return { type: 'message', message: o['message'] ? messageFromJson(o['message']) : undefined };
            return undefined;
        })(),
        event: o['event'] !== undefined ? o['event'] ? eventFromJson(o['event']) : undefined : undefined,
        message: o['message'] !== undefined ? o['message'] ? messageFromJson(o['message']) : undefined : undefined,
    };
}
export function getMultiParticipantsResponseToJson(m) {
    const o = {};
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => participantToJson(e));
    }
    return o;
}
export function getMultiParticipantsResponseFromJson(o) {
    var _a;
    return {
        participants: ((_a = o['participants']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
    };
}
export function searchConversationsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.location !== undefined)
        o['location'] = m.location;
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function searchConversationsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        accountGroupId: (_b = o['accountGroupId']) !== null && _b !== void 0 ? _b : '',
        location: (_c = o['location']) !== null && _c !== void 0 ? _c : 'PLATFORM_LOCATION_UNDEFINED',
        searchTerm: (_d = o['searchTerm']) !== null && _d !== void 0 ? _d : '',
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function searchConversationsResponseToJson(m) {
    const o = {};
    if (m.conversations !== undefined) {
        o['conversations'] = m.conversations.map(e => searchConversationsResponseDetailedConversationToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function searchConversationsResponseFromJson(o) {
    var _a;
    return {
        conversations: ((_a = o['conversations']) !== null && _a !== void 0 ? _a : []).map(e => searchConversationsResponseDetailedConversationFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function searchConversationsResponseDetailedConversationToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    if (m.latestMessage !== undefined)
        o['latestMessage'] = messageToJson(m.latestMessage);
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => participantToJson(e));
    }
    return o;
}
export function searchConversationsResponseDetailedConversationFromJson(o) {
    var _a;
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
        latestMessage: o['latestMessage'] ? messageFromJson(o['latestMessage']) : undefined,
        participants: ((_a = o['participants']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
    };
}
export function getMultiConversationMessageCountRequestToJson(m) {
    const o = {};
    if (m.conversationIds !== undefined) {
        o['conversationIds'] = m.conversationIds.map(e => e);
    }
    return o;
}
export function getMultiConversationMessageCountRequestFromJson(o) {
    var _a;
    return {
        conversationIds: ((_a = o['conversationIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function conversationMessageCountToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.count !== undefined)
        o['count'] = m.count;
    return o;
}
export function conversationMessageCountFromJson(o) {
    var _a, _b;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        count: (_b = o['count']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function getMultiConversationMessageCountResponseToJson(m) {
    const o = {};
    if (m.messageCounts !== undefined) {
        o['messageCounts'] = m.messageCounts.map(e => conversationMessageCountToJson(e));
    }
    if (m.counts !== undefined) {
        const map = {};
        for (const [k, v] of Object.entries(m.counts)) {
            map[k] = v;
        }
        o['counts'] = map;
    }
    return o;
}
export function getMultiConversationMessageCountResponseFromJson(o) {
    var _a;
    return {
        messageCounts: ((_a = o['messageCounts']) !== null && _a !== void 0 ? _a : []).map(e => conversationMessageCountFromJson(e)),
        counts: o['counts']
            ? Object.fromEntries(Object.entries(o['counts']).map(([k, v]) => [k, v]))
            : {},
    };
}
export function addMultiParticipantsRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => participantToJson(e));
    }
    return o;
}
export function addMultiParticipantsRequestFromJson(o) {
    var _a, _b;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        participants: ((_b = o['participants']) !== null && _b !== void 0 ? _b : []).map(e => participantFromJson(e)),
    };
}
export function addMultiParticipantsResponseToJson(m) {
    const o = {};
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => participantToJson(e));
    }
    return o;
}
export function addMultiParticipantsResponseFromJson(o) {
    var _a;
    return {
        participants: ((_a = o['participants']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
    };
}
export function setLastSeenResponseToJson(m) {
    const o = {};
    if (m.participant !== undefined)
        o['participant'] = participantToJson(m.participant);
    return o;
}
export function setLastSeenResponseFromJson(o) {
    return {
        participant: o['participant'] ? participantFromJson(o['participant']) : undefined,
    };
}
export function getParticipantsByKeyResponseToJson(m) {
    const o = {};
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => participantToJson(e));
    }
    if (m.participant !== undefined)
        o['participant'] = participantToJson(m.participant);
    return o;
}
export function getParticipantsByKeyResponseFromJson(o) {
    var _a;
    return {
        participants: ((_a = o['participants']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
        participant: o['participant'] ? participantFromJson(o['participant']) : undefined,
    };
}
export function upsertConfigurationRequestToJson(m) {
    const o = {};
    if (m.configuration !== undefined)
        o['configuration'] = configurationToJson(m.configuration);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function upsertConfigurationRequestFromJson(o) {
    return {
        configuration: o['configuration'] ? configurationFromJson(o['configuration']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function upsertConfigurationResponseToJson(m) {
    const o = {};
    if (m.configuration !== undefined)
        o['configuration'] = configurationToJson(m.configuration);
    return o;
}
export function upsertConfigurationResponseFromJson(o) {
    return {
        configuration: o['configuration'] ? configurationFromJson(o['configuration']) : undefined,
    };
}
export function upsertProductFeatureRequestToJson(m) {
    const o = {};
    if (m.productFeature !== undefined)
        o['productFeature'] = productFeatureToJson(m.productFeature);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.subjectParticipant !== undefined)
        o['subjectParticipant'] = subjectParticipantToJson(m.subjectParticipant);
    return o;
}
export function upsertProductFeatureRequestFromJson(o) {
    return {
        productFeature: o['productFeature'] ? productFeatureFromJson(o['productFeature']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        subjectParticipant: o['subjectParticipant'] ? subjectParticipantFromJson(o['subjectParticipant']) : undefined,
    };
}
export function upsertProductFeatureResponseToJson(m) {
    const o = {};
    if (m.productFeature !== undefined)
        o['productFeature'] = productFeatureToJson(m.productFeature);
    return o;
}
export function upsertProductFeatureResponseFromJson(o) {
    return {
        productFeature: o['productFeature'] ? productFeatureFromJson(o['productFeature']) : undefined,
    };
}
export function getConfigurationRequestToJson(m) {
    const o = {};
    if (m.subjectParticipant !== undefined)
        o['subjectParticipant'] = subjectParticipantToJson(m.subjectParticipant);
    return o;
}
export function getConfigurationRequestFromJson(o) {
    return {
        subjectParticipant: o['subjectParticipant'] ? subjectParticipantFromJson(o['subjectParticipant']) : undefined,
    };
}
export function getConfigurationResponseToJson(m) {
    const o = {};
    if (m.configuration !== undefined)
        o['configuration'] = configurationToJson(m.configuration);
    return o;
}
export function getConfigurationResponseFromJson(o) {
    return {
        configuration: o['configuration'] ? configurationFromJson(o['configuration']) : undefined,
    };
}
export function getMultiConfigurationRequestToJson(m) {
    const o = {};
    if (m.subjectParticipants !== undefined) {
        o['subjectParticipants'] = m.subjectParticipants.map(e => subjectParticipantToJson(e));
    }
    return o;
}
export function getMultiConfigurationRequestFromJson(o) {
    var _a;
    return {
        subjectParticipants: ((_a = o['subjectParticipants']) !== null && _a !== void 0 ? _a : []).map(e => subjectParticipantFromJson(e)),
    };
}
export function getMultiConfigurationResponseToJson(m) {
    const o = {};
    if (m.configurations !== undefined) {
        o['configurations'] = m.configurations.map(e => configurationToJson(e));
    }
    return o;
}
export function getMultiConfigurationResponseFromJson(o) {
    var _a;
    return {
        configurations: ((_a = o['configurations']) !== null && _a !== void 0 ? _a : []).map(e => configurationFromJson(e)),
    };
}
export function getConversationViewsRequestToJson(m) {
    const o = {};
    if (m.participantId !== undefined)
        o['participantId'] = m.participantId;
    return o;
}
export function getConversationViewsRequestFromJson(o) {
    var _a;
    return {
        participantId: (_a = o['participantId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getConversationViewsResponseToJson(m) {
    const o = {};
    if (m.views !== undefined) {
        o['views'] = m.views.map(e => viewToJson(e));
    }
    return o;
}
export function getConversationViewsResponseFromJson(o) {
    var _a;
    return {
        views: ((_a = o['views']) !== null && _a !== void 0 ? _a : []).map(e => viewFromJson(e)),
    };
}
export function addConversationToConversationViewRequestToJson(m) {
    const o = {};
    if (m.viewId !== undefined)
        o['viewId'] = m.viewId;
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.participantId !== undefined)
        o['participantId'] = m.participantId;
    return o;
}
export function addConversationToConversationViewRequestFromJson(o) {
    var _a, _b, _c;
    return {
        viewId: (_a = o['viewId']) !== null && _a !== void 0 ? _a : '',
        conversationId: (_b = o['conversationId']) !== null && _b !== void 0 ? _b : '',
        participantId: (_c = o['participantId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function removeConversationFromConversationViewRequestToJson(m) {
    const o = {};
    if (m.viewId !== undefined)
        o['viewId'] = m.viewId;
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.participantId !== undefined)
        o['participantId'] = m.participantId;
    return o;
}
export function removeConversationFromConversationViewRequestFromJson(o) {
    var _a, _b, _c;
    return {
        viewId: (_a = o['viewId']) !== null && _a !== void 0 ? _a : '',
        conversationId: (_b = o['conversationId']) !== null && _b !== void 0 ? _b : '',
        participantId: (_c = o['participantId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function createWidgetConversationRequestToJson(m) {
    const o = {};
    if (m.widgetId !== undefined)
        o['widgetId'] = m.widgetId;
    if (m.chatSourceUrl !== undefined)
        o['chatSourceUrl'] = m.chatSourceUrl;
    if (m.greetingMessage !== undefined)
        o['greetingMessage'] = m.greetingMessage;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    if (m.selectedNamespace !== undefined)
        o['selectedNamespace'] = m.selectedNamespace;
    return o;
}
export function createWidgetConversationRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        widgetId: (_a = o['widgetId']) !== null && _a !== void 0 ? _a : '',
        chatSourceUrl: (_b = o['chatSourceUrl']) !== null && _b !== void 0 ? _b : '',
        greetingMessage: (_c = o['greetingMessage']) !== null && _c !== void 0 ? _c : '',
        metadata: ((_d = o['metadata']) !== null && _d !== void 0 ? _d : []).map(e => keyValuePairFromJson(e)),
        selectedNamespace: (_e = o['selectedNamespace']) !== null && _e !== void 0 ? _e : '',
    };
}
export function createWidgetConversationResponseToJson(m) {
    const o = {};
    if (m.widgetParticipantToken !== undefined)
        o['widgetParticipantToken'] = m.widgetParticipantToken;
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    if (m.greetingMessageId !== undefined)
        o['greetingMessageId'] = m.greetingMessageId;
    return o;
}
export function createWidgetConversationResponseFromJson(o) {
    var _a, _b;
    return {
        widgetParticipantToken: (_a = o['widgetParticipantToken']) !== null && _a !== void 0 ? _a : '',
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
        greetingMessageId: (_b = o['greetingMessageId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function sendWidgetMessageRequestToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.body !== undefined)
        o['body'] = m.body;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => metadataToJson(e));
    }
    if (m.location !== undefined)
        o['location'] = m.location;
    return o;
}
export function sendWidgetMessageRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'MESSAGE_TYPE_MESSAGE',
        body: (_b = o['body']) !== null && _b !== void 0 ? _b : '',
        metadata: ((_c = o['metadata']) !== null && _c !== void 0 ? _c : []).map(e => metadataFromJson(e)),
        location: (_d = o['location']) !== null && _d !== void 0 ? _d : 'PLATFORM_LOCATION_UNDEFINED',
    };
}
export function sendWidgetMessageResponseToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.createdAt !== undefined)
        o['createdAt'] = m.createdAt.toISOString();
    return o;
}
export function sendWidgetMessageResponseFromJson(o) {
    var _a;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
        createdAt: o['createdAt'] ? new Date(o['createdAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function getAvailableChannelsForConversationRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function getAvailableChannelsForConversationRequestFromJson(o) {
    var _a;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function channelStatusToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.i18nKey !== undefined)
        o['i18nKey'] = m.i18nKey;
    return o;
}
export function channelStatusFromJson(o) {
    var _a, _b;
    return {
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'ERROR',
        i18nKey: (_b = o['i18nKey']) !== null && _b !== void 0 ? _b : '',
    };
}
export function channelAvailabilityToJson(m) {
    const o = {};
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.isAvailable !== undefined)
        o['isAvailable'] = m.isAvailable;
    if (m.statuses !== undefined) {
        o['statuses'] = m.statuses.map(e => channelStatusToJson(e));
    }
    return o;
}
export function channelAvailabilityFromJson(o) {
    var _a, _b, _c;
    return {
        channel: (_a = o['channel']) !== null && _a !== void 0 ? _a : 'CONVERSATION_CHANNEL_UNDEFINED',
        isAvailable: (_b = o['isAvailable']) !== null && _b !== void 0 ? _b : false,
        statuses: ((_c = o['statuses']) !== null && _c !== void 0 ? _c : []).map(e => channelStatusFromJson(e)),
    };
}
export function getAvailableChannelsForConversationResponseToJson(m) {
    const o = {};
    if (m.channels !== undefined) {
        o['channels'] = m.channels.map(e => e);
    }
    if (m.preferredChannel !== undefined)
        o['preferredChannel'] = m.preferredChannel;
    if (m.channelAvailabilities !== undefined) {
        o['channelAvailabilities'] = m.channelAvailabilities.map(e => channelAvailabilityToJson(e));
    }
    return o;
}
export function getAvailableChannelsForConversationResponseFromJson(o) {
    var _a, _b, _c;
    return {
        channels: ((_a = o['channels']) !== null && _a !== void 0 ? _a : []).map(e => e),
        preferredChannel: (_b = o['preferredChannel']) !== null && _b !== void 0 ? _b : 'CONVERSATION_CHANNEL_UNDEFINED',
        channelAvailabilities: ((_c = o['channelAvailabilities']) !== null && _c !== void 0 ? _c : []).map(e => channelAvailabilityFromJson(e)),
    };
}
export function evaluateResponseRequestToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.sentiment !== undefined)
        o['sentiment'] = m.sentiment;
    if (m.comment !== undefined)
        o['comment'] = m.comment;
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.evaluatedItemId !== undefined) {
        if (m.evaluatedItemId.type === 'evaluatedEventId') {
            o['evaluatedEventId'] = m.evaluatedItemId.evaluatedEventId;
        }
        if (m.evaluatedItemId.type === 'evaluatedMessageId') {
            o['evaluatedMessageId'] = m.evaluatedItemId.evaluatedMessageId;
        }
    }
    else {
        if (m.evaluatedEventId !== undefined)
            o['evaluatedEventId'] = m.evaluatedEventId;
        if (m.evaluatedMessageId !== undefined)
            o['evaluatedMessageId'] = m.evaluatedMessageId;
    }
    return o;
}
export function evaluateResponseRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
        sentiment: (_b = o['sentiment']) !== null && _b !== void 0 ? _b : 'EVALUATION_SENTIMENT_UNDEFINED',
        comment: (_c = o['comment']) !== null && _c !== void 0 ? _c : '',
        conversationId: (_d = o['conversationId']) !== null && _d !== void 0 ? _d : '',
        evaluatedItemId: (() => {
            if (o['evaluatedEventId'] !== undefined)
                return { type: 'evaluatedEventId', evaluatedEventId: o['evaluatedEventId'] };
            if (o['evaluatedMessageId'] !== undefined)
                return { type: 'evaluatedMessageId', evaluatedMessageId: o['evaluatedMessageId'] };
            return undefined;
        })(),
        evaluatedEventId: o['evaluatedEventId'] !== undefined ? o['evaluatedEventId'] : undefined,
        evaluatedMessageId: o['evaluatedMessageId'] !== undefined ? o['evaluatedMessageId'] : undefined,
    };
}
export function listResponseEvaluationsRequestToJson(m) {
    const o = {};
    if (m.summarize !== undefined)
        o['summarize'] = m.summarize;
    if (m.subjectParticipant !== undefined)
        o['subjectParticipant'] = subjectParticipantToJson(m.subjectParticipant);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    if (m.createdAfter !== undefined)
        o['createdAfter'] = m.createdAfter.toISOString();
    if (m.createdBefore !== undefined)
        o['createdBefore'] = m.createdBefore.toISOString();
    if (m.evaluationType !== undefined) {
        o['evaluationType'] = m.evaluationType.map(e => e);
    }
    return o;
}
export function listResponseEvaluationsRequestFromJson(o) {
    var _a, _b;
    return {
        summarize: (_a = o['summarize']) !== null && _a !== void 0 ? _a : false,
        subjectParticipant: o['subjectParticipant'] ? subjectParticipantFromJson(o['subjectParticipant']) : undefined,
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        createdAfter: o['createdAfter'] ? new Date(o['createdAfter']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        createdBefore: o['createdBefore'] ? new Date(o['createdBefore']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        evaluationType: ((_b = o['evaluationType']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function listResponseEvaluationsResponseToJson(m) {
    const o = {};
    if (m.evaluations !== undefined) {
        o['evaluations'] = m.evaluations.map(e => responseEvaluationToJson(e));
    }
    if (m.summary !== undefined)
        o['summary'] = listResponseEvaluationsResponseSummaryToJson(m.summary);
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listResponseEvaluationsResponseFromJson(o) {
    var _a;
    return {
        evaluations: ((_a = o['evaluations']) !== null && _a !== void 0 ? _a : []).map(e => responseEvaluationFromJson(e)),
        summary: o['summary'] ? listResponseEvaluationsResponseSummaryFromJson(o['summary']) : undefined,
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function listResponseEvaluationsResponseSummaryToJson(m) {
    const o = {};
    if (m.feedbackThemes !== undefined) {
        o['feedbackThemes'] = m.feedbackThemes.map(e => listResponseEvaluationsResponseSummaryThemeToJson(e));
    }
    return o;
}
export function listResponseEvaluationsResponseSummaryFromJson(o) {
    var _a;
    return {
        feedbackThemes: ((_a = o['feedbackThemes']) !== null && _a !== void 0 ? _a : []).map(e => listResponseEvaluationsResponseSummaryThemeFromJson(e)),
    };
}
export function listResponseEvaluationsResponseSummaryThemeToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.examples !== undefined) {
        o['examples'] = m.examples.map(e => e);
    }
    return o;
}
export function listResponseEvaluationsResponseSummaryThemeFromJson(o) {
    var _a, _b, _c;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        description: (_b = o['description']) !== null && _b !== void 0 ? _b : '',
        examples: ((_c = o['examples']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function createWidgetRequestToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.color !== undefined)
        o['color'] = m.color;
    if (m.allowedUrls !== undefined) {
        o['allowedUrls'] = m.allowedUrls.map(e => e);
    }
    if (m.welcomeMessage !== undefined)
        o['welcomeMessage'] = m.welcomeMessage;
    if (m.dataSources !== undefined)
        o['dataSources'] = dataSourcesToJson(m.dataSources);
    if (m.textColor !== undefined)
        o['textColor'] = m.textColor;
    if (m.accentColor !== undefined)
        o['accentColor'] = m.accentColor;
    if (m.accentTextColor !== undefined)
        o['accentTextColor'] = m.accentTextColor;
    if (m.skipContactCapture !== undefined)
        o['skipContactCapture'] = m.skipContactCapture;
    if (m.additionalPromptInstructions !== undefined)
        o['additionalPromptInstructions'] = m.additionalPromptInstructions;
    if (m.assistantName !== undefined)
        o['assistantName'] = m.assistantName;
    if (m.assistantAvatarUrl !== undefined)
        o['assistantAvatarUrl'] = m.assistantAvatarUrl;
    if (m.position !== undefined)
        o['position'] = m.position;
    if (m.hideMobileCta !== undefined)
        o['hideMobileCta'] = m.hideMobileCta;
    if (m.customGreetingMessage !== undefined)
        o['customGreetingMessage'] = m.customGreetingMessage;
    if (m.enableGreetingMessage !== undefined)
        o['enableGreetingMessage'] = m.enableGreetingMessage;
    if (m.widgetType !== undefined)
        o['widgetType'] = m.widgetType;
    if (m.assistantId !== undefined)
        o['assistantId'] = m.assistantId;
    if (m.associatedNamespaces !== undefined) {
        o['associatedNamespaces'] = m.associatedNamespaces.map(e => e);
    }
    return o;
}
export function createWidgetRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
        color: (_c = o['color']) !== null && _c !== void 0 ? _c : '',
        allowedUrls: ((_d = o['allowedUrls']) !== null && _d !== void 0 ? _d : []).map(e => e),
        welcomeMessage: (_e = o['welcomeMessage']) !== null && _e !== void 0 ? _e : '',
        dataSources: o['dataSources'] ? dataSourcesFromJson(o['dataSources']) : undefined,
        textColor: (_f = o['textColor']) !== null && _f !== void 0 ? _f : '',
        accentColor: (_g = o['accentColor']) !== null && _g !== void 0 ? _g : '',
        accentTextColor: (_h = o['accentTextColor']) !== null && _h !== void 0 ? _h : '',
        skipContactCapture: (_j = o['skipContactCapture']) !== null && _j !== void 0 ? _j : false,
        additionalPromptInstructions: (_k = o['additionalPromptInstructions']) !== null && _k !== void 0 ? _k : '',
        assistantName: (_l = o['assistantName']) !== null && _l !== void 0 ? _l : '',
        assistantAvatarUrl: (_m = o['assistantAvatarUrl']) !== null && _m !== void 0 ? _m : '',
        position: (_o = o['position']) !== null && _o !== void 0 ? _o : 'WIDGET_POSITION_UNSPECIFIED',
        hideMobileCta: (_p = o['hideMobileCta']) !== null && _p !== void 0 ? _p : false,
        customGreetingMessage: (_q = o['customGreetingMessage']) !== null && _q !== void 0 ? _q : '',
        enableGreetingMessage: (_r = o['enableGreetingMessage']) !== null && _r !== void 0 ? _r : false,
        widgetType: (_s = o['widgetType']) !== null && _s !== void 0 ? _s : '',
        assistantId: (_t = o['assistantId']) !== null && _t !== void 0 ? _t : '',
        associatedNamespaces: ((_u = o['associatedNamespaces']) !== null && _u !== void 0 ? _u : []).map(e => e),
    };
}
export function createWidgetResponseToJson(m) {
    const o = {};
    if (m.widget !== undefined)
        o['widget'] = widgetToJson(m.widget);
    return o;
}
export function createWidgetResponseFromJson(o) {
    return {
        widget: o['widget'] ? widgetFromJson(o['widget']) : undefined,
    };
}
export function getWidgetRequestToJson(m) {
    const o = {};
    if (m.widgetId !== undefined)
        o['widgetId'] = m.widgetId;
    return o;
}
export function getWidgetRequestFromJson(o) {
    var _a;
    return {
        widgetId: (_a = o['widgetId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getWidgetResponseToJson(m) {
    const o = {};
    if (m.widget !== undefined)
        o['widget'] = widgetToJson(m.widget);
    return o;
}
export function getWidgetResponseFromJson(o) {
    return {
        widget: o['widget'] ? widgetFromJson(o['widget']) : undefined,
    };
}
export function getMultiWidgetRequestToJson(m) {
    const o = {};
    if (m.widgetIds !== undefined) {
        o['widgetIds'] = m.widgetIds.map(e => e);
    }
    return o;
}
export function getMultiWidgetRequestFromJson(o) {
    var _a;
    return {
        widgetIds: ((_a = o['widgetIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getMultiWidgetResponseToJson(m) {
    const o = {};
    if (m.widgets !== undefined) {
        o['widgets'] = m.widgets.map(e => widgetToJson(e));
    }
    return o;
}
export function getMultiWidgetResponseFromJson(o) {
    var _a;
    return {
        widgets: ((_a = o['widgets']) !== null && _a !== void 0 ? _a : []).map(e => widgetFromJson(e)),
    };
}
export function widgetVisitToJson(m) {
    const o = {};
    if (m.visitorId !== undefined)
        o['visitorId'] = m.visitorId;
    if (m.visitId !== undefined)
        o['visitId'] = m.visitId;
    return o;
}
export function widgetVisitFromJson(o) {
    var _a, _b;
    return {
        visitorId: (_a = o['visitorId']) !== null && _a !== void 0 ? _a : '',
        visitId: (_b = o['visitId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getWidgetConfigRequestToJson(m) {
    const o = {};
    if (m.widgetId !== undefined)
        o['widgetId'] = m.widgetId;
    if (m.visitData !== undefined)
        o['visitData'] = widgetVisitToJson(m.visitData);
    return o;
}
export function getWidgetConfigRequestFromJson(o) {
    var _a;
    return {
        widgetId: (_a = o['widgetId']) !== null && _a !== void 0 ? _a : '',
        visitData: o['visitData'] ? widgetVisitFromJson(o['visitData']) : undefined,
    };
}
export function getWidgetConfigResponseToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.color !== undefined)
        o['color'] = m.color;
    if (m.isEnabled !== undefined)
        o['isEnabled'] = m.isEnabled;
    if (m.welcomeMessage !== undefined)
        o['welcomeMessage'] = m.welcomeMessage;
    if (m.textColor !== undefined)
        o['textColor'] = m.textColor;
    if (m.accentColor !== undefined)
        o['accentColor'] = m.accentColor;
    if (m.accentTextColor !== undefined)
        o['accentTextColor'] = m.accentTextColor;
    if (m.skipContactCapture !== undefined)
        o['skipContactCapture'] = m.skipContactCapture;
    if (m.widgetTopSpace !== undefined)
        o['widgetTopSpace'] = m.widgetTopSpace;
    if (m.assistantName !== undefined)
        o['assistantName'] = m.assistantName;
    if (m.assistantAvatarUrl !== undefined)
        o['assistantAvatarUrl'] = m.assistantAvatarUrl;
    if (m.position !== undefined)
        o['position'] = m.position;
    if (m.hideMobileCta !== undefined)
        o['hideMobileCta'] = m.hideMobileCta;
    if (m.customGreetingMessage !== undefined)
        o['customGreetingMessage'] = m.customGreetingMessage;
    if (m.enableGreetingMessage !== undefined)
        o['enableGreetingMessage'] = m.enableGreetingMessage;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.poweredByName !== undefined)
        o['poweredByName'] = m.poweredByName;
    if (m.poweredByWebsite !== undefined)
        o['poweredByWebsite'] = m.poweredByWebsite;
    if (m.showFooterContent !== undefined)
        o['showFooterContent'] = m.showFooterContent;
    if (m.greetingMessageType !== undefined)
        o['greetingMessageType'] = m.greetingMessageType;
    if (m.widgetType !== undefined)
        o['widgetType'] = m.widgetType;
    return o;
}
export function getWidgetConfigResponseFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        color: (_b = o['color']) !== null && _b !== void 0 ? _b : '',
        isEnabled: (_c = o['isEnabled']) !== null && _c !== void 0 ? _c : false,
        welcomeMessage: (_d = o['welcomeMessage']) !== null && _d !== void 0 ? _d : '',
        textColor: (_e = o['textColor']) !== null && _e !== void 0 ? _e : '',
        accentColor: (_f = o['accentColor']) !== null && _f !== void 0 ? _f : '',
        accentTextColor: (_g = o['accentTextColor']) !== null && _g !== void 0 ? _g : '',
        skipContactCapture: (_h = o['skipContactCapture']) !== null && _h !== void 0 ? _h : false,
        widgetTopSpace: (_j = o['widgetTopSpace']) !== null && _j !== void 0 ? _j : 0,
        assistantName: (_k = o['assistantName']) !== null && _k !== void 0 ? _k : '',
        assistantAvatarUrl: (_l = o['assistantAvatarUrl']) !== null && _l !== void 0 ? _l : '',
        position: (_m = o['position']) !== null && _m !== void 0 ? _m : 'WIDGET_POSITION_UNSPECIFIED',
        hideMobileCta: (_o = o['hideMobileCta']) !== null && _o !== void 0 ? _o : false,
        customGreetingMessage: (_p = o['customGreetingMessage']) !== null && _p !== void 0 ? _p : '',
        enableGreetingMessage: (_q = o['enableGreetingMessage']) !== null && _q !== void 0 ? _q : false,
        namespace: (_r = o['namespace']) !== null && _r !== void 0 ? _r : '',
        poweredByName: (_s = o['poweredByName']) !== null && _s !== void 0 ? _s : '',
        poweredByWebsite: (_t = o['poweredByWebsite']) !== null && _t !== void 0 ? _t : '',
        showFooterContent: (_u = o['showFooterContent']) !== null && _u !== void 0 ? _u : false,
        greetingMessageType: (_v = o['greetingMessageType']) !== null && _v !== void 0 ? _v : 'GREETING_MESSAGE_UNDEFINED',
        widgetType: (_w = o['widgetType']) !== null && _w !== void 0 ? _w : '',
    };
}
export function updateWidgetRequestToJson(m) {
    const o = {};
    if (m.widgetId !== undefined)
        o['widgetId'] = m.widgetId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.color !== undefined)
        o['color'] = m.color;
    if (m.allowedUrls !== undefined) {
        o['allowedUrls'] = m.allowedUrls.map(e => e);
    }
    if (m.welcomeMessage !== undefined)
        o['welcomeMessage'] = m.welcomeMessage;
    if (m.isEnabled !== undefined)
        o['isEnabled'] = m.isEnabled;
    if (m.textColor !== undefined)
        o['textColor'] = m.textColor;
    if (m.accentColor !== undefined)
        o['accentColor'] = m.accentColor;
    if (m.accentTextColor !== undefined)
        o['accentTextColor'] = m.accentTextColor;
    if (m.skipContactCapture !== undefined)
        o['skipContactCapture'] = m.skipContactCapture;
    if (m.additionalPromptInstructions !== undefined)
        o['additionalPromptInstructions'] = m.additionalPromptInstructions;
    if (m.assistantName !== undefined)
        o['assistantName'] = m.assistantName;
    if (m.assistantAvatarUrl !== undefined)
        o['assistantAvatarUrl'] = m.assistantAvatarUrl;
    if (m.position !== undefined)
        o['position'] = m.position;
    if (m.hideMobileCta !== undefined)
        o['hideMobileCta'] = m.hideMobileCta;
    if (m.customGreetingMessage !== undefined)
        o['customGreetingMessage'] = m.customGreetingMessage;
    if (m.enableGreetingMessage !== undefined)
        o['enableGreetingMessage'] = m.enableGreetingMessage;
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.assistantId !== undefined)
        o['assistantId'] = m.assistantId;
    if (m.associatedNamespaces !== undefined) {
        o['associatedNamespaces'] = m.associatedNamespaces.map(e => e);
    }
    return o;
}
export function updateWidgetRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    return {
        widgetId: (_a = o['widgetId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        color: (_c = o['color']) !== null && _c !== void 0 ? _c : '',
        allowedUrls: ((_d = o['allowedUrls']) !== null && _d !== void 0 ? _d : []).map(e => e),
        welcomeMessage: (_e = o['welcomeMessage']) !== null && _e !== void 0 ? _e : '',
        isEnabled: (_f = o['isEnabled']) !== null && _f !== void 0 ? _f : false,
        textColor: (_g = o['textColor']) !== null && _g !== void 0 ? _g : '',
        accentColor: (_h = o['accentColor']) !== null && _h !== void 0 ? _h : '',
        accentTextColor: (_j = o['accentTextColor']) !== null && _j !== void 0 ? _j : '',
        skipContactCapture: (_k = o['skipContactCapture']) !== null && _k !== void 0 ? _k : false,
        additionalPromptInstructions: (_l = o['additionalPromptInstructions']) !== null && _l !== void 0 ? _l : '',
        assistantName: (_m = o['assistantName']) !== null && _m !== void 0 ? _m : '',
        assistantAvatarUrl: (_o = o['assistantAvatarUrl']) !== null && _o !== void 0 ? _o : '',
        position: (_p = o['position']) !== null && _p !== void 0 ? _p : 'WIDGET_POSITION_UNSPECIFIED',
        hideMobileCta: (_q = o['hideMobileCta']) !== null && _q !== void 0 ? _q : false,
        customGreetingMessage: (_r = o['customGreetingMessage']) !== null && _r !== void 0 ? _r : '',
        enableGreetingMessage: (_s = o['enableGreetingMessage']) !== null && _s !== void 0 ? _s : false,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        assistantId: (_t = o['assistantId']) !== null && _t !== void 0 ? _t : '',
        associatedNamespaces: ((_u = o['associatedNamespaces']) !== null && _u !== void 0 ? _u : []).map(e => e),
    };
}
export function updateWidgetResponseToJson(m) {
    const o = {};
    if (m.widget !== undefined)
        o['widget'] = widgetToJson(m.widget);
    return o;
}
export function updateWidgetResponseFromJson(o) {
    return {
        widget: o['widget'] ? widgetFromJson(o['widget']) : undefined,
    };
}
export function deleteWidgetRequestToJson(m) {
    const o = {};
    if (m.widgetId !== undefined)
        o['widgetId'] = m.widgetId;
    return o;
}
export function deleteWidgetRequestFromJson(o) {
    var _a;
    return {
        widgetId: (_a = o['widgetId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listWidgetsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    if (m.options !== undefined)
        o['options'] = listWidgetsRequestListWidgetsFiltersToJson(m.options);
    return o;
}
export function listWidgetsRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        options: o['options'] ? listWidgetsRequestListWidgetsFiltersFromJson(o['options']) : undefined,
    };
}
export function listWidgetsRequestListWidgetsFiltersToJson(m) {
    const o = {};
    if (m.namespaces !== undefined) {
        o['namespaces'] = m.namespaces.map(e => e);
    }
    if (m.widgetTypes !== undefined) {
        o['widgetTypes'] = m.widgetTypes.map(e => e);
    }
    return o;
}
export function listWidgetsRequestListWidgetsFiltersFromJson(o) {
    var _a, _b;
    return {
        namespaces: ((_a = o['namespaces']) !== null && _a !== void 0 ? _a : []).map(e => e),
        widgetTypes: ((_b = o['widgetTypes']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function listWidgetsResponseToJson(m) {
    const o = {};
    if (m.widgets !== undefined) {
        o['widgets'] = m.widgets.map(e => widgetToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listWidgetsResponseFromJson(o) {
    var _a;
    return {
        widgets: ((_a = o['widgets']) !== null && _a !== void 0 ? _a : []).map(e => widgetFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function getMultiWidgetMessagesRequestToJson(m) {
    const o = {};
    if (m.messageIds !== undefined) {
        o['messageIds'] = m.messageIds.map(e => e);
    }
    return o;
}
export function getMultiWidgetMessagesRequestFromJson(o) {
    var _a;
    return {
        messageIds: ((_a = o['messageIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getMultiWidgetMessagesResponseToJson(m) {
    const o = {};
    if (m.messages !== undefined) {
        o['messages'] = m.messages.map(e => messageToJson(e));
    }
    return o;
}
export function getMultiWidgetMessagesResponseFromJson(o) {
    var _a;
    return {
        messages: ((_a = o['messages']) !== null && _a !== void 0 ? _a : []).map(e => messageFromJson(e)),
    };
}
export function getWidgetConversationResponseToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    return o;
}
export function getWidgetConversationResponseFromJson(o) {
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
    };
}
export function listMessageTemplateRequestToJson(m) {
    const o = {};
    if (m.subjectParticipant !== undefined)
        o['subjectParticipant'] = subjectParticipantToJson(m.subjectParticipant);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listMessageTemplateRequestFromJson(o) {
    return {
        subjectParticipant: o['subjectParticipant'] ? subjectParticipantFromJson(o['subjectParticipant']) : undefined,
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listMessageTemplateResponseToJson(m) {
    const o = {};
    if (m.templates !== undefined) {
        o['templates'] = m.templates.map(e => messageTemplateToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listMessageTemplateResponseFromJson(o) {
    var _a;
    return {
        templates: ((_a = o['templates']) !== null && _a !== void 0 ? _a : []).map(e => messageTemplateFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function createMessageTemplateRequestToJson(m) {
    const o = {};
    if (m.template !== undefined)
        o['template'] = messageTemplateToJson(m.template);
    if (m.subjectParticipant !== undefined)
        o['subjectParticipant'] = subjectParticipantToJson(m.subjectParticipant);
    return o;
}
export function createMessageTemplateRequestFromJson(o) {
    return {
        template: o['template'] ? messageTemplateFromJson(o['template']) : undefined,
        subjectParticipant: o['subjectParticipant'] ? subjectParticipantFromJson(o['subjectParticipant']) : undefined,
    };
}
export function createMessageTemplateResponseToJson(m) {
    const o = {};
    if (m.template !== undefined)
        o['template'] = messageTemplateToJson(m.template);
    return o;
}
export function createMessageTemplateResponseFromJson(o) {
    return {
        template: o['template'] ? messageTemplateFromJson(o['template']) : undefined,
    };
}
export function updateMessageTemplateRequestToJson(m) {
    const o = {};
    if (m.template !== undefined)
        o['template'] = messageTemplateToJson(m.template);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateMessageTemplateRequestFromJson(o) {
    return {
        template: o['template'] ? messageTemplateFromJson(o['template']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function updateMessageTemplateResponseToJson(m) {
    const o = {};
    if (m.template !== undefined)
        o['template'] = messageTemplateToJson(m.template);
    return o;
}
export function updateMessageTemplateResponseFromJson(o) {
    return {
        template: o['template'] ? messageTemplateFromJson(o['template']) : undefined,
    };
}
export function deleteMessageTemplateRequestToJson(m) {
    const o = {};
    if (m.templateId !== undefined)
        o['templateId'] = m.templateId;
    return o;
}
export function deleteMessageTemplateRequestFromJson(o) {
    var _a;
    return {
        templateId: (_a = o['templateId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getMessageTemplateRequestToJson(m) {
    const o = {};
    if (m.templateId !== undefined)
        o['templateId'] = m.templateId;
    if (m.hydrationOptions !== undefined)
        o['hydrationOptions'] = getMessageTemplateRequestHydrationOptionsToJson(m.hydrationOptions);
    return o;
}
export function getMessageTemplateRequestFromJson(o) {
    var _a;
    return {
        templateId: (_a = o['templateId']) !== null && _a !== void 0 ? _a : '',
        hydrationOptions: o['hydrationOptions'] ? getMessageTemplateRequestHydrationOptionsFromJson(o['hydrationOptions']) : undefined,
    };
}
export function getMessageTemplateRequestHydrationOptionsToJson(m) {
    const o = {};
    if (m.hydrationEntities !== undefined) {
        o['hydrationEntities'] = m.hydrationEntities.map(e => getMessageTemplateRequestHydrationOptionsHydrationEntityToJson(e));
    }
    return o;
}
export function getMessageTemplateRequestHydrationOptionsFromJson(o) {
    var _a;
    return {
        hydrationEntities: ((_a = o['hydrationEntities']) !== null && _a !== void 0 ? _a : []).map(e => getMessageTemplateRequestHydrationOptionsHydrationEntityFromJson(e)),
    };
}
export function getMessageTemplateRequestHydrationOptionsHydrationEntityToJson(m) {
    const o = {};
    if (m.entityType !== undefined)
        o['entityType'] = m.entityType;
    if (m.entityId !== undefined)
        o['entityId'] = m.entityId;
    return o;
}
export function getMessageTemplateRequestHydrationOptionsHydrationEntityFromJson(o) {
    var _a, _b;
    return {
        entityType: (_a = o['entityType']) !== null && _a !== void 0 ? _a : 'ENTITY_TYPE_UNDEFINED',
        entityId: (_b = o['entityId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getMessageTemplateResponseToJson(m) {
    const o = {};
    if (m.template !== undefined)
        o['template'] = messageTemplateToJson(m.template);
    if (m.hydrationInformation !== undefined)
        o['hydrationInformation'] = getMessageTemplateResponseHydrationInformationToJson(m.hydrationInformation);
    return o;
}
export function getMessageTemplateResponseFromJson(o) {
    return {
        template: o['template'] ? messageTemplateFromJson(o['template']) : undefined,
        hydrationInformation: o['hydrationInformation'] ? getMessageTemplateResponseHydrationInformationFromJson(o['hydrationInformation']) : undefined,
    };
}
export function getMessageTemplateResponseHydrationInformationToJson(m) {
    const o = {};
    if (m.allFieldsHydrated !== undefined)
        o['allFieldsHydrated'] = m.allFieldsHydrated;
    return o;
}
export function getMessageTemplateResponseHydrationInformationFromJson(o) {
    var _a;
    return {
        allFieldsHydrated: (_a = o['allFieldsHydrated']) !== null && _a !== void 0 ? _a : false,
    };
}
export function getConversationSummaryRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function getConversationSummaryRequestFromJson(o) {
    var _a;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getConversationSummaryResponseToJson(m) {
    const o = {};
    if (m.summary !== undefined)
        o['summary'] = m.summary;
    return o;
}
export function getConversationSummaryResponseFromJson(o) {
    var _a;
    return {
        summary: (_a = o['summary']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getOwnerEmailRequestToJson(m) {
    const o = {};
    if (m.subjectParticipant !== undefined)
        o['subjectParticipant'] = subjectParticipantToJson(m.subjectParticipant);
    return o;
}
export function getOwnerEmailRequestFromJson(o) {
    return {
        subjectParticipant: o['subjectParticipant'] ? subjectParticipantFromJson(o['subjectParticipant']) : undefined,
    };
}
export function getOwnerEmailResponseToJson(m) {
    const o = {};
    if (m.forwardingEmail !== undefined)
        o['forwardingEmail'] = m.forwardingEmail;
    return o;
}
export function getOwnerEmailResponseFromJson(o) {
    var _a;
    return {
        forwardingEmail: (_a = o['forwardingEmail']) !== null && _a !== void 0 ? _a : '',
    };
}
export function capturedLeadToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.phone !== undefined)
        o['phone'] = m.phone;
    if (m.leadId !== undefined) {
        if (m.leadId.type === 'contactId') {
            o['contactId'] = m.leadId.contactId;
        }
    }
    else {
        if (m.contactId !== undefined)
            o['contactId'] = m.contactId;
    }
    return o;
}
export function capturedLeadFromJson(o) {
    var _a, _b, _c;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        email: (_b = o['email']) !== null && _b !== void 0 ? _b : '',
        phone: (_c = o['phone']) !== null && _c !== void 0 ? _c : '',
        leadId: (() => {
            if (o['contactId'] !== undefined)
                return { type: 'contactId', contactId: o['contactId'] };
            return undefined;
        })(),
        contactId: o['contactId'] !== undefined ? o['contactId'] : undefined,
    };
}
export function newInboxLeadCapturedRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.parentNamespace !== undefined)
        o['parentNamespace'] = m.parentNamespace;
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.conversationSummary !== undefined)
        o['conversationSummary'] = m.conversationSummary;
    if (m.capturedLead !== undefined)
        o['capturedLead'] = capturedLeadToJson(m.capturedLead);
    if (m.source !== undefined)
        o['source'] = m.source;
    if (m.capturedAt !== undefined)
        o['capturedAt'] = m.capturedAt.toISOString();
    if (m.message !== undefined)
        o['message'] = m.message;
    if (m.initiatorId !== undefined)
        o['initiatorId'] = m.initiatorId;
    if (m.media !== undefined) {
        o['media'] = m.media.map(e => mediaToJson(e));
    }
    return o;
}
export function newInboxLeadCapturedRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        parentNamespace: (_b = o['parentNamespace']) !== null && _b !== void 0 ? _b : '',
        conversationId: (_c = o['conversationId']) !== null && _c !== void 0 ? _c : '',
        conversationSummary: (_d = o['conversationSummary']) !== null && _d !== void 0 ? _d : '',
        capturedLead: o['capturedLead'] ? capturedLeadFromJson(o['capturedLead']) : undefined,
        source: (_e = o['source']) !== null && _e !== void 0 ? _e : '',
        capturedAt: o['capturedAt'] ? new Date(o['capturedAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        message: (_f = o['message']) !== null && _f !== void 0 ? _f : '',
        initiatorId: (_g = o['initiatorId']) !== null && _g !== void 0 ? _g : '',
        media: ((_h = o['media']) !== null && _h !== void 0 ? _h : []).map(e => mediaFromJson(e)),
    };
}
export function newInboxLeadCapturedResponseToJson(m) {
    const o = {};
    return o;
}
export function newInboxLeadCapturedResponseFromJson(o) {
    return {};
}
export function getMultiEventsRequestToJson(m) {
    const o = {};
    if (m.eventIds !== undefined) {
        o['eventIds'] = m.eventIds.map(e => e);
    }
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.excludeInternalEvents !== undefined)
        o['excludeInternalEvents'] = m.excludeInternalEvents;
    return o;
}
export function getMultiEventsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        eventIds: ((_a = o['eventIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        conversationId: (_b = o['conversationId']) !== null && _b !== void 0 ? _b : '',
        excludeInternalEvents: (_c = o['excludeInternalEvents']) !== null && _c !== void 0 ? _c : false,
    };
}
export function getMultiEventsResponseToJson(m) {
    const o = {};
    if (m.events !== undefined) {
        o['events'] = m.events.map(e => eventToJson(e));
    }
    return o;
}
export function getMultiEventsResponseFromJson(o) {
    var _a;
    return {
        events: ((_a = o['events']) !== null && _a !== void 0 ? _a : []).map(e => eventFromJson(e)),
    };
}
export function deleteEventByIdempotencyKeyRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    return o;
}
export function deleteEventByIdempotencyKeyRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        idempotencyKey: (_b = o['idempotencyKey']) !== null && _b !== void 0 ? _b : '',
        reason: (_c = o['reason']) !== null && _c !== void 0 ? _c : '',
    };
}
export function deleteEventByIdempotencyKeyResponseToJson(m) {
    const o = {};
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted;
    if (m.eventId !== undefined)
        o['eventId'] = m.eventId;
    return o;
}
export function deleteEventByIdempotencyKeyResponseFromJson(o) {
    var _a, _b;
    return {
        deleted: (_a = o['deleted']) !== null && _a !== void 0 ? _a : false,
        eventId: (_b = o['eventId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function makeToolCallRequestToJson(m) {
    const o = {};
    if (m.messageOption !== undefined)
        o['messageOption'] = makeToolCallRequestMessageOptionToJson(m.messageOption);
    if (m.payload !== undefined)
        o['payload'] = m.payload;
    return o;
}
export function makeToolCallRequestFromJson(o) {
    var _a;
    return {
        messageOption: o['messageOption'] ? makeToolCallRequestMessageOptionFromJson(o['messageOption']) : undefined,
        payload: (_a = o['payload']) !== null && _a !== void 0 ? _a : '',
    };
}
export function makeToolCallRequestMessageOptionToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.selectedOptionIds !== undefined) {
        o['selectedOptionIds'] = m.selectedOptionIds.map(e => e);
    }
    return o;
}
export function makeToolCallRequestMessageOptionFromJson(o) {
    var _a, _b;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
        selectedOptionIds: ((_b = o['selectedOptionIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function makeToolCallResponseToJson(m) {
    const o = {};
    return o;
}
export function makeToolCallResponseFromJson(o) {
    return {};
}
export function exportConversationsRequestToJson(m) {
    const o = {};
    if (m.filterOptions !== undefined)
        o['filterOptions'] = exportConversationsRequestFilterOptionsToJson(m.filterOptions);
    return o;
}
export function exportConversationsRequestFromJson(o) {
    return {
        filterOptions: o['filterOptions'] ? exportConversationsRequestFilterOptionsFromJson(o['filterOptions']) : undefined,
    };
}
export function exportConversationsRequestFilterOptionsToJson(m) {
    const o = {};
    if (m.subjectParticipant !== undefined)
        o['subjectParticipant'] = subjectParticipantToJson(m.subjectParticipant);
    if (m.startTime !== undefined)
        o['startTime'] = m.startTime.toISOString();
    if (m.endTime !== undefined)
        o['endTime'] = m.endTime.toISOString();
    if (m.platformLocation !== undefined)
        o['platformLocation'] = m.platformLocation;
    return o;
}
export function exportConversationsRequestFilterOptionsFromJson(o) {
    var _a;
    return {
        subjectParticipant: o['subjectParticipant'] ? subjectParticipantFromJson(o['subjectParticipant']) : undefined,
        startTime: o['startTime'] ? new Date(o['startTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        endTime: o['endTime'] ? new Date(o['endTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        platformLocation: (_a = o['platformLocation']) !== null && _a !== void 0 ? _a : 'PLATFORM_LOCATION_UNDEFINED',
    };
}
export function exportConversationsResponseToJson(m) {
    const o = {};
    if (m.workflowId !== undefined)
        o['workflowId'] = m.workflowId;
    return o;
}
export function exportConversationsResponseFromJson(o) {
    var _a;
    return {
        workflowId: (_a = o['workflowId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listConversationExportsRequestToJson(m) {
    const o = {};
    if (m.filterOptions !== undefined)
        o['filterOptions'] = listConversationExportsRequestFilterOptionsToJson(m.filterOptions);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listConversationExportsRequestFromJson(o) {
    return {
        filterOptions: o['filterOptions'] ? listConversationExportsRequestFilterOptionsFromJson(o['filterOptions']) : undefined,
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listConversationExportsRequestFilterOptionsToJson(m) {
    const o = {};
    if (m.platformLocation !== undefined)
        o['platformLocation'] = m.platformLocation;
    if (m.subjectParticipant !== undefined)
        o['subjectParticipant'] = subjectParticipantToJson(m.subjectParticipant);
    return o;
}
export function listConversationExportsRequestFilterOptionsFromJson(o) {
    var _a;
    return {
        platformLocation: (_a = o['platformLocation']) !== null && _a !== void 0 ? _a : 'PLATFORM_LOCATION_UNDEFINED',
        subjectParticipant: o['subjectParticipant'] ? subjectParticipantFromJson(o['subjectParticipant']) : undefined,
    };
}
export function listConversationExportsResponseToJson(m) {
    const o = {};
    if (m.record !== undefined) {
        o['record'] = m.record.map(e => conversationExportRecordToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listConversationExportsResponseFromJson(o) {
    var _a;
    return {
        record: ((_a = o['record']) !== null && _a !== void 0 ? _a : []).map(e => conversationExportRecordFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function listCommunicationChannelsInfoRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function listCommunicationChannelsInfoRequestFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function communicationInfoToJson(m) {
    const o = {};
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    return o;
}
export function communicationInfoFromJson(o) {
    var _a, _b;
    return {
        channel: (_a = o['channel']) !== null && _a !== void 0 ? _a : 'COMMUNICATION_CHANNEL_TYPE_UNDEFINED',
        identifier: (_b = o['identifier']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listCommunicationChannelsInfoResponseToJson(m) {
    const o = {};
    if (m.communicationInfo !== undefined) {
        o['communicationInfo'] = m.communicationInfo.map(e => communicationInfoToJson(e));
    }
    return o;
}
export function listCommunicationChannelsInfoResponseFromJson(o) {
    var _a;
    return {
        communicationInfo: ((_a = o['communicationInfo']) !== null && _a !== void 0 ? _a : []).map(e => communicationInfoFromJson(e)),
    };
}
export function listConversationsFiltersToJson(m) {
    const o = {};
    if (m.channels !== undefined) {
        o['channels'] = m.channels.map(e => e);
    }
    if (m.isOpen !== undefined)
        o['isOpen'] = m.isOpen;
    if (m.unreadOnly !== undefined)
        o['unreadOnly'] = m.unreadOnly;
    if (m.awaitingResponseOnly !== undefined)
        o['awaitingResponseOnly'] = m.awaitingResponseOnly;
    if (m.isAnonymous !== undefined)
        o['isAnonymous'] = m.isAnonymous;
    if (m.assigneeUserId !== undefined)
        o['assigneeUserId'] = m.assigneeUserId;
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.isSpam !== undefined)
        o['isSpam'] = m.isSpam;
    return o;
}
export function listConversationsFiltersFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        channels: ((_a = o['channels']) !== null && _a !== void 0 ? _a : []).map(e => e),
        isOpen: o['isOpen'],
        unreadOnly: (_b = o['unreadOnly']) !== null && _b !== void 0 ? _b : false,
        awaitingResponseOnly: (_c = o['awaitingResponseOnly']) !== null && _c !== void 0 ? _c : false,
        isAnonymous: o['isAnonymous'],
        assigneeUserId: (_d = o['assigneeUserId']) !== null && _d !== void 0 ? _d : '',
        searchTerm: (_e = o['searchTerm']) !== null && _e !== void 0 ? _e : '',
        isSpam: o['isSpam'],
    };
}
export function listConversationsRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.participantId !== undefined)
        o['participantId'] = m.participantId;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    if (m.filters !== undefined)
        o['filters'] = listConversationsFiltersToJson(m.filters);
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function listConversationsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        participantId: (_b = o['participantId']) !== null && _b !== void 0 ? _b : '',
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        filters: o['filters'] ? listConversationsFiltersFromJson(o['filters']) : undefined,
        namespace: (_c = o['namespace']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listConversationsResponseToJson(m) {
    const o = {};
    if (m.conversations !== undefined) {
        o['conversations'] = m.conversations.map(e => listConversationsResponseInboxConversationToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listConversationsResponseFromJson(o) {
    var _a;
    return {
        conversations: ((_a = o['conversations']) !== null && _a !== void 0 ? _a : []).map(e => listConversationsResponseInboxConversationFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function listConversationsResponseInboxConversationToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    if (m.latestMessage !== undefined)
        o['latestMessage'] = messageToJson(m.latestMessage);
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => participantToJson(e));
    }
    return o;
}
export function listConversationsResponseInboxConversationFromJson(o) {
    var _a;
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
        latestMessage: o['latestMessage'] ? messageFromJson(o['latestMessage']) : undefined,
        participants: ((_a = o['participants']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
    };
}
export function assignConversationRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.assigneeUserIds !== undefined) {
        o['assigneeUserIds'] = m.assigneeUserIds.map(e => e);
    }
    if (m.linkToCrmOwner !== undefined)
        o['linkToCrmOwner'] = m.linkToCrmOwner;
    return o;
}
export function assignConversationRequestFromJson(o) {
    var _a, _b, _c;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        assigneeUserIds: ((_b = o['assigneeUserIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
        linkToCrmOwner: (_c = o['linkToCrmOwner']) !== null && _c !== void 0 ? _c : false,
    };
}
export function assignConversationResponseToJson(m) {
    const o = {};
    return o;
}
export function assignConversationResponseFromJson(o) {
    return {};
}
export function getMediaConstraintsRequestToJson(m) {
    const o = {};
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    return o;
}
export function getMediaConstraintsRequestFromJson(o) {
    var _a;
    return {
        channel: (_a = o['channel']) !== null && _a !== void 0 ? _a : 'CONVERSATION_CHANNEL_UNDEFINED',
    };
}
export function mediaTypeConstraintToJson(m) {
    const o = {};
    if (m.mimeType !== undefined)
        o['mimeType'] = m.mimeType;
    if (m.maxFileSizeBytes !== undefined)
        o['maxFileSizeBytes'] = m.maxFileSizeBytes;
    if (m.maxFileCount !== undefined)
        o['maxFileCount'] = m.maxFileCount;
    return o;
}
export function mediaTypeConstraintFromJson(o) {
    var _a, _b;
    return {
        mimeType: (_a = o['mimeType']) !== null && _a !== void 0 ? _a : '',
        maxFileSizeBytes: (_b = o['maxFileSizeBytes']) !== null && _b !== void 0 ? _b : 0,
        maxFileCount: o['maxFileCount'],
    };
}
export function channelMediaConstraintsToJson(m) {
    const o = {};
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.typeConstraints !== undefined) {
        o['typeConstraints'] = m.typeConstraints.map(e => mediaTypeConstraintToJson(e));
    }
    if (m.maxTotalPayloadBytes !== undefined)
        o['maxTotalPayloadBytes'] = m.maxTotalPayloadBytes;
    if (m.maxFileCount !== undefined)
        o['maxFileCount'] = m.maxFileCount;
    if (m.serverCompresses !== undefined)
        o['serverCompresses'] = m.serverCompresses;
    if (m.compressionNote !== undefined)
        o['compressionNote'] = m.compressionNote;
    return o;
}
export function channelMediaConstraintsFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        channel: (_a = o['channel']) !== null && _a !== void 0 ? _a : 'CONVERSATION_CHANNEL_UNDEFINED',
        typeConstraints: ((_b = o['typeConstraints']) !== null && _b !== void 0 ? _b : []).map(e => mediaTypeConstraintFromJson(e)),
        maxTotalPayloadBytes: (_c = o['maxTotalPayloadBytes']) !== null && _c !== void 0 ? _c : 0,
        maxFileCount: (_d = o['maxFileCount']) !== null && _d !== void 0 ? _d : 0,
        serverCompresses: (_e = o['serverCompresses']) !== null && _e !== void 0 ? _e : false,
        compressionNote: (_f = o['compressionNote']) !== null && _f !== void 0 ? _f : '',
    };
}
export function getMediaConstraintsResponseToJson(m) {
    const o = {};
    if (m.channels !== undefined) {
        o['channels'] = m.channels.map(e => channelMediaConstraintsToJson(e));
    }
    return o;
}
export function getMediaConstraintsResponseFromJson(o) {
    var _a;
    return {
        channels: ((_a = o['channels']) !== null && _a !== void 0 ? _a : []).map(e => channelMediaConstraintsFromJson(e)),
    };
}
